webpackJsonp([2,0],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(27);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueRouter = __webpack_require__(260);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _App = __webpack_require__(246);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _Home = __webpack_require__(247);
	
	var _Home2 = _interopRequireDefault(_Home);
	
	var _Messages = __webpack_require__(249);
	
	var _Messages2 = _interopRequireDefault(_Messages);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueRouter2.default);
	
	var routes = [{
	  path: '/',
	  name: 'home',
	  component: _Home2.default
	}, {
	  path: '/:channel_name',
	  name: 'channel',
	  component: _Messages2.default,
	  children: [{
	    path: 'search-:search',
	    name: 'channel_search',
	    component: _Messages2.default,
	    children: [{
	      path: 'page-:page',
	      name: 'channel_search_page',
	      component: _Messages2.default,
	      children: [{
	        path: 'ts-:id',
	        name: 'channel_search_message',
	        component: _Messages2.default
	      }]
	    }]
	  }, {
	    path: 'page-:page',
	    name: 'channel_page',
	    component: _Messages2.default,
	    children: [{
	      path: 'ts-:id',
	      name: 'channel_message',
	      component: _Messages2.default
	    }]
	  }]
	}];
	
	var router = new _vueRouter2.default({
	  routes: routes,
	  mode: document.location.href.indexOf('hash_mode') !== -1 ? 'hash' : 'history'
	});
	
	new _vue2.default({
	  el: '#app',
	  template: '<App/>',
	  components: { App: _App2.default },
	  router: router
	});

/***/ }),

/***/ 29:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var isDevDomain = exports.isDevDomain = document.location.host.indexOf('localhost') !== -1;
	
	var getEl = exports.getEl = function getEl(id) {
	  return document.getElementById(id);
	};
	
	var elOffsetTop = exports.elOffsetTop = function elOffsetTop(el) {
	  var r = el.getBoundingClientRect();
	  return r.top;
	};
	
	var elHeight = exports.elHeight = function elHeight(el) {
	  var r = el.getBoundingClientRect();
	  return r.bottom - r.top;
	};
	
	var elFullHeight = exports.elFullHeight = function elFullHeight(el) {
	  var styles = window.getComputedStyle(el),
	      margin = parseFloat(styles['marginTop']) + parseFloat(styles['marginBottom']);
	
	  return Math.ceil(el.offsetHeight + margin);
	};
	
	var winHeight = exports.winHeight = function winHeight() {
	  var w = window,
	      d = document,
	      e = d.documentElement,
	      g = d.getElementsByTagName('body')[0];
	
	  return w.innerHeight || e.clientHeight || g.clientHeight;
	};
	
	var monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
	
	var monthFullNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
	
	var formatDate = exports.formatDate = function formatDate(dt) {
	  var full = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  if (full) return monthFullNames[dt.getMonth()] + ' ' + dt.getDate() + ', ' + dt.getFullYear();
	
	  var hours = dt.getHours(),
	      minutes = dt.getMinutes();
	  return monthNames[dt.getMonth()] + ' ' + dt.getDate() + ', ' + dt.getFullYear() + ' ' + (hours < 10 ? '0' : '') + hours + ':' + (minutes < 10 ? '0' : '') + minutes;
	};
	
	var requestAnimFrame = function () {
	  return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || function (callback) {
	    window.setTimeout(callback, 1000 / 60);
	  };
	}();
	
	var scrollTo = exports.scrollTo = function scrollTo(element, scrollTargetY) {
	  var speed = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2000;
	  var easing = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'easeInOutQuint';
	
	
	  var scrollY = element.scrollTop,
	      currentTime = 0;
	
	  var time = Math.max(.1, Math.min(Math.abs(scrollY - scrollTargetY) / speed, .4));
	
	  var easingEquations = {
	    easeOutSine: function easeOutSine(pos) {
	      return Math.sin(pos * (Math.PI / 2));
	    },
	    easeInOutSine: function easeInOutSine(pos) {
	      return -0.5 * (Math.cos(Math.PI * pos) - 1);
	    },
	    easeInOutQuint: function easeInOutQuint(pos) {
	      if ((pos /= 0.5) < 1) {
	        return 0.5 * Math.pow(pos, 5);
	      }
	      return 0.5 * (Math.pow(pos - 2, 5) + 2);
	    }
	  };
	
	  function tick() {
	    currentTime += 1 / 60;
	
	    var p = currentTime / time,
	        t = easingEquations[easing](p);
	
	    if (p < 1) {
	      requestAnimFrame(tick);
	      element.scrollTop = scrollY + (scrollTargetY - scrollY) * t;
	    } else {
	      element.scrollTop = scrollTargetY;
	    }
	  }
	
	  tick();
	};
	
	var queryParams = exports.queryParams = function queryParams(url) {
	  var vars = [],
	      hash = void 0,
	      index = url.indexOf('?');
	  if (index < 0) {
	    return [];
	  } else {
	    var hashes = url.slice(index + 1).split('&'),
	        i = void 0;
	    for (i = 0; i < hashes.length; i++) {
	      hash = hashes[i].split('=');
	      vars.push(hash[0]);
	      vars[hash[0]] = hash[1];
	    }
	    return vars;
	  }
	};

/***/ }),

/***/ 51:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.event = undefined;
	
	var _keys = __webpack_require__(110);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _vue = __webpack_require__(27);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var event = {
	  bus: null,
	
	  init: function init() {
	    if (!this.bus) {
	      this.bus = new _vue2.default();
	    }
	
	    return this;
	  },
	  emit: function emit(name) {
	    var _bus;
	
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    (_bus = this.bus).$emit.apply(_bus, [name].concat(args));
	    return this;
	  },
	  on: function on() {
	    var _this = this,
	        _arguments = arguments;
	
	    if (arguments.length === 2) {
	      this.bus.$on(arguments[0], arguments[1]);
	    } else {
	      (0, _keys2.default)(arguments[0]).forEach(function (key) {
	        _this.bus.$on(key, _arguments[0][key]);
	      });
	    }
	
	    return this;
	  }
	};
	
	exports.event = event;

/***/ }),

/***/ 52:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _axios = __webpack_require__(45);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var apiUrl = window.location.protocol + '//' + window.location.host + '/v1/';
	
	exports.default = {
	  getTeams: function getTeams(teamDomain) {
	    var params = {};
	    if (teamDomain) params.domain = teamDomain;
	    return _axios2.default.get(apiUrl + 'team', { params: params });
	  },
	  getChannels: function getChannels(teamId) {
	    return _axios2.default.get(apiUrl + 'channels', { params: { team_id: teamId } });
	  },
	  getMessages: function getMessages(team_id, channel_id, size, offset, search) {
	    var sort = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 'desc';
	    var tsTo = arguments[6];
	    var tsFrom = arguments[7];
	
	    var params = { size: size, team: team_id };
	    if (channel_id) params.channel = channel_id;
	    if (offset !== undefined) params.offset = offset;
	    if (search) {
	      params.q = search.query;
	      if (size > 0) {
	        params.aggs = 1;
	      }
	    }
	    if (sort === 'asc') params.sort = sort;
	    if (tsTo) params.to = tsTo / 1000000;
	
	    return _axios2.default.get(apiUrl + 'messages', { params: params });
	  }
	};

/***/ }),

/***/ 82:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/logo.b781b16.png";

/***/ }),

/***/ 101:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _axios = __webpack_require__(45);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _TopBar = __webpack_require__(252);
	
	var _TopBar2 = _interopRequireDefault(_TopBar);
	
	var _SideBar = __webpack_require__(251);
	
	var _SideBar2 = _interopRequireDefault(_SideBar);
	
	var _services = __webpack_require__(52);
	
	var _services2 = _interopRequireDefault(_services);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'app',
	  components: {
	    TopBar: _TopBar2.default, SideBar: _SideBar2.default
	  },
	  data: function data() {
	    return {
	      appIsReady: null,
	      showMenu: false,
	      error: null,
	      errorType: null,
	      domain: null,
	      team: null,
	      channels: [],
	      users: null,
	      channel: null
	    };
	  },
	  created: function created() {
	    _axios2.default.defaults.headers.common['X-Alt-Referer'] = document.location.origin;
	  },
	  mounted: function mounted() {
	    this.detectTeam();
	  },
	
	  watch: {
	    $route: function $route(newRoute, oldRoute) {
	      if (newRoute.name == 'home') {
	        this.channel = null;
	      } else {
	        this.detectChannel();
	      }
	
	      if (this.showMenu) this.showMenu = false;
	    }
	  },
	  computed: {
	    channelIDsToName: function channelIDsToName() {
	      var channelIDsToName = {};
	      this.channels && this.channels.forEach(function (channel) {
	        channelIDsToName[channel.channel_id] = channel.name;
	      });
	      return channelIDsToName;
	    }
	  },
	  methods: {
	    detectTeam: function detectTeam() {
	      this.getTeams(null);
	    },
	    detectChannel: function detectChannel() {
	      var channel_name = this.$route.params.channel_name;
	      if (!channel_name) {
	        var defaultChannel = this.channels.find(function (each) {
	          return each.is_general === true;
	        });
	        if (defaultChannel) {
	          this.$router.push({ name: 'channel', params: { 'channel_name': defaultChannel.name } });
	        }
	        return;
	      }
	      this.channel = channel_name === '-' ? { name: '-', channel_id: '' } : this.channels.find(function (each) {
	        return each.name == channel_name;
	      });
	      if (!this.channel && channel_name !== '-') {
	        this.error = 'Channel "' + channel_name + '" not found.';
	        this.errorType = 'known';
	      }
	    },
	    getTeams: function getTeams(teamDomain) {
	      var _this = this;
	
	      _services2.default.getTeams(teamDomain).then(function (response) {
	        if (!response.data.team) {
	          _this.error = 'Team by domain "' + teamDomain + '" not found.';
	          _this.errorType = 'known';
	          return;
	        }
	        _this.team = response.data.team[0];
	        _this.getChannels();
	      }).catch(this.onError);
	    },
	    getChannels: function getChannels() {
	      var _this2 = this;
	
	      _services2.default.getChannels(this.team.team_id).then(function (response) {
	        _this2.channels = response.data.channels;
	        if (!_this2.channels) {
	          _this2.error = 'No channels archived yet for "' + _this2.team.domain + '" team.';
	          _this2.errorType = 'known';
	          return;
	        }
	        _this2.appIsReady = true;
	        _this2.detectChannel();
	      }).catch(this.onError);
	    },
	    onMenuToggle: function onMenuToggle() {
	      this.showMenu = !this.showMenu;
	    },
	    onError: function onError(error) {
	      if (error) {
	        this.error = error.response && error.response.data ? error.response.data : 'Unexpected error!';
	      } else {
	        this.error = null;
	        this.errorType = null;
	      }
	    }
	  }
	};

/***/ }),

/***/ 102:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: ['appIsReady'],
	  watch: {
	    channel: function channel() {
	      this.getMessages();
	    }
	  },
	  mounted: function mounted() {},
	
	  methods: {}
	};

/***/ }),

/***/ 103:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: ['loading', 'size']
	};

/***/ }),

/***/ 104:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(112);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _extends2 = __webpack_require__(111);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vue = __webpack_require__(27);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _throttle = __webpack_require__(80);
	
	var _throttle2 = _interopRequireDefault(_throttle);
	
	var _isEqual = __webpack_require__(232);
	
	var _isEqual2 = _interopRequireDefault(_isEqual);
	
	var _services = __webpack_require__(52);
	
	var _services2 = _interopRequireDefault(_services);
	
	var _nodeEmoji = __webpack_require__(241);
	
	var _nodeEmoji2 = _interopRequireDefault(_nodeEmoji);
	
	var _utils = __webpack_require__(29);
	
	var _Paginate = __webpack_require__(250);
	
	var _Paginate2 = _interopRequireDefault(_Paginate);
	
	var _LoaderIcon = __webpack_require__(248);
	
	var _LoaderIcon2 = _interopRequireDefault(_LoaderIcon);
	
	var _event = __webpack_require__(51);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var perPage = 100,
	    keepPages = 4,
	    maxOffset = 10000;
	
	var container = void 0,
	    messagesEl = void 0,
	    scrollPages = void 0,
	    currentWinHeight = (0, _utils.winHeight)(),
	    scrollThrottle = void 0,
	    resizeThrottle = void 0,
	    mounted = void 0,
	    channelAggs = void 0;
	
	_event.event.init();
	
	exports.default = {
	  props: ['channel', 'team', 'channelIDsToName', 'appIsReady'],
	
	  components: {
	    Paginate: _Paginate2.default, LoaderIcon: _LoaderIcon2.default
	  },
	
	  data: function data() {
	    return {
	      messages: [],
	      users: [],
	
	      search: null,
	      componentIsReady: null,
	      activeMessageId: null,
	      targetMessageId: null,
	      targetMessageIdLoading: null,
	      targetMessageError: null,
	      error: null,
	      isLoading: null,
	      realTotalMessages: null,
	      totalMessages: null,
	      lastPage: 0,
	      currentPage: 0
	    };
	  },
	
	
	  watch: {
	    error: function error(_error) {
	      this.$emit('error', _error);
	    },
	    appIsReady: function appIsReady(isReady) {
	      if (!mounted) this.onMounted();
	
	      _vue2.default.nextTick(function () {
	        if (isReady) {
	          var pagination = (0, _utils.getEl)('pagination');
	          pagination && (0, _utils.getEl)('app').appendChild(pagination);
	        }
	      });
	    },
	    $route: function $route(route, oldRoute) {
	      this.onRouteChange(route, oldRoute);
	    }
	  },
	
	  mounted: function mounted() {
	    if (!this.appIsReady) return;
	    this.onMounted();
	  },
	  beforeDestroy: function beforeDestroy() {
	    this.stopTrackScroll();
	    this.stopTrackResize();
	    this.reset();
	    this.emitChannelAggs(null);
	    var pagination = (0, _utils.getEl)('pagination');
	    pagination && (0, _utils.getEl)('app').removeChild((0, _utils.getEl)('pagination'));
	    mounted = false;
	  },
	
	
	  methods: {
	    reset: function reset() {
	      this.totalMessages = null;
	      this.realTotalMessages = null;
	      this.currentPage = 0;
	      this.lastPage = 0;
	      this.error = null;
	      this.search = null;
	      this.targetMessageId = null;
	      this.targetMessageIdLoading = null;
	      this.targetMessageError = null;
	      scrollPages = {};
	    },
	    onMounted: function onMounted() {
	      mounted = true;
	      container = (0, _utils.getEl)('main_container');
	      messagesEl = (0, _utils.getEl)('messages');
	      this.onRouteChange(this.$route, null, true);
	    },
	    onRouteChange: function onRouteChange(route, oldRoute) {
	      var byMount = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	
	      var reloadNeeded = true;
	      console.log('Route change' + (byMount ? ' byMount' : ''), route.name, route.params);
	
	      var messageFound = this.markMessage();
	
	      if (!byMount && (messageFound || route.name === 'channel_page' && this.channel.name === route.params.channel_name || route.name === 'channel_search_page' && this.channel.name === oldRoute.params.channel_name && this.search && this.search.query === route.params.search)) {
	        reloadNeeded = false;
	      }
	
	      if (reloadNeeded === false && this.channel.name !== oldRoute.params.channel_name) {
	          this.reset();
	        }
	
	      if (reloadNeeded) this.initMessages();
	
	      if (byMount) return;
	
	      var newPage = parseInt(route.params.page);
	      if (newPage && newPage != this.currentPage) {
	        this.changePage(newPage);
	      }
	    },
	    onError: function onError(error) {
	      this.error = error;
	    },
	
	
	    changePage: function changePage(page, extend) {
	      if (this.isLoading) return;
	
	      if (!extend) {
	        if (scrollPages[page] !== undefined) {
	          this.scrollToEl((0, _utils.getEl)(scrollPages[page].first));
	          return;
	        }
	
	        scrollPages = {};
	      }
	
	      this.getMessages(extend, page);
	    },
	
	    setCurrentPage: function setCurrentPage(page) {
	      var setUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	      var replaceUrl = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	      if (page == this.currentPage) return;
	
	      this.currentPage = page;
	
	      if (setUrl && this.$route.params.page != page) {
	        this.setPageUrl(replaceUrl);
	      }
	    },
	    setPageUrl: function setPageUrl() {
	      var replaceUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	      if (!this.currentPage) return;
	
	      var func = replaceUrl ? this.$router.replace : this.$router.push;
	      var routeName = this.$route.name,
	          params = (0, _extends3.default)({}, this.$route.params);
	      if (routeName === 'channel_message' || routeName === 'channel_search_message') {
	        routeName = 'channel_page';
	      } else if (routeName.indexOf('_page') === -1) {
	        routeName += '_page';
	      }
	      params.page = this.currentPage;
	      delete params.id;
	
	      func.call(this.$router, { name: routeName, params: params });
	    },
	    markMessage: function markMessage() {
	      var animate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	      this.activeMessageId = null;
	      if (this.currentPage === 0) return;
	      var newMessageId = this.$route.params.id || null;
	      if (newMessageId != this.activeMessageId) {
	        if (newMessageId) {
	          var messageEl = (0, _utils.getEl)(newMessageId);
	          if (messageEl) {
	            this.activeMessageId = newMessageId;
	            this.scrollToEl(messageEl, animate, -15);
	            return true;
	          } else {
	            console.warn('Message with ID: ' + newMessageId + ' not found on page: ' + this.currentPage);
	          }
	        }
	      }
	    },
	    handleSearch: function handleSearch() {
	      var searchQuery = this.$route.params.search;
	      this.search = searchQuery ? { query: searchQuery } : null;
	    },
	    initMessages: function initMessages() {
	      this.reset();
	      this.handleSearch();
	      this.getMessages(null, parseInt(this.$route.params.page));
	    },
	    getMessages: function getMessages() {
	      var extend = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	      var page = arguments[1];
	      var channelId = arguments[2];
	
	      var _this = this;
	
	      var messageTs = arguments[3];
	      var messagesBeforeTs = arguments[4];
	
	      if (!messageTs) this.isLoading = !extend ? true : extend;
	      page = page || 0;
	
	      if (page > 0 && this.lastPage === 0) {
	        channelId = channelId ? channelId : this.channel.channel_id;
	        _services2.default.getMessages(this.team.team_id, channelId, 0, undefined, !messageTs ? this.search : null).then(function (response) {
	          _this.setCount(response.data.total);
	          _this.calculatePages(page);
	          if (!messageTs) {
	            _this._getMessages(extend, page);
	          } else {
	            _this.targetMessageIdLoading = null;
	            var messagesAfter = _this.realTotalMessages - messagesBeforeTs;
	            if (messagesAfter > maxOffset) {
	              _this.targetMessageError = 'Message context is unreachable';
	              return;
	            }
	
	            _this.search = null;
	            page = _this.lastPage - Math.floor(messagesAfter / perPage);
	
	            _this.$router.push({
	              name: 'channel_message',
	              params: {
	                channel_name: _this.channelIDsToName[channelId],
	                page: page,
	                id: messageTs
	              }
	            });
	          }
	        }).catch(this.onError);
	        return;
	      }
	
	      this._getMessages(extend, page);
	    },
	
	
	    _getMessages: function _getMessages(extend, page) {
	      var _this2 = this;
	
	      var offset = perPage * Math.max(0, this.lastPage - page);
	      _services2.default.getMessages(this.team.team_id, this.channel.channel_id, perPage, offset, this.search).then(function (response) {
	        _this2.onMessagesData(response.data, extend, page);
	      }).catch(this.onError);
	    },
	
	    setCount: function setCount(total) {
	      this.realTotalMessages = total;
	      this.totalMessages = Math.min(total, maxOffset);
	    },
	
	    onMessagesData: function onMessagesData(data, extend, page) {
	      this.users = data.related.users;
	      this.setCount(data.total);
	
	      if (this.search && !(0, _isEqual2.default)(channelAggs, data.aggs.buckets)) {
	        this.emitChannelAggs(data.aggs.buckets);
	      }
	
	      page = this.calculatePages(page);
	
	      if (!extend) {
	        this.setCurrentPage(page, true, !page);
	      }
	
	      var newMessages = this.formatMessages(data.messages, page);
	      if (extend === null) {
	        this.messages = newMessages;
	      } else if (extend === 'top') {
	        this.messages = [].concat((0, _toConsumableArray3.default)(newMessages), (0, _toConsumableArray3.default)(this.messages.slice(0, (keepPages - 1) * perPage)));
	      } else if (extend === 'bottom') {
	        this.messages = [].concat((0, _toConsumableArray3.default)(this.messages.slice(-(keepPages - 1) * perPage)), (0, _toConsumableArray3.default)(newMessages));
	      }
	
	      if (!this.messages.length) {
	        this.isLoading = false;
	        return;
	      }
	
	      scrollPages[page] = {
	        first: data.messages[0].ts_id,
	        last: data.messages[data.messages.length - 1].ts_id
	      };
	
	      this.iterateScrollPages(function (key) {
	        if (extend === 'top' && key > page + keepPages - 1 || extend === 'bottom' && key < page - keepPages + 1) {
	          delete scrollPages[key];
	        }
	      });
	
	      this.trackScroll();
	
	      this.trackResize();
	
	      this.handleScroll(extend, page);
	
	      this.isLoading = false;
	    },
	
	
	    emitChannelAggs: function emitChannelAggs(aggs) {
	      channelAggs = aggs;
	      _event.event.emit('channelAggs', channelAggs, this.search ? this.search.query : null);
	    },
	
	    iterateScrollPages: function iterateScrollPages(func) {
	      for (var key in scrollPages) {
	        if (!scrollPages.hasOwnProperty(key)) continue;
	        key = parseInt(key);
	        var ret = func(key, scrollPages[key]);
	        if (ret === false) break;
	      }
	    },
	    calculatePages: function calculatePages(page) {
	      var totalPages = Math.ceil(this.totalMessages / perPage);
	      this.lastPage = totalPages;
	      if (page === 0) {
	        this.setCurrentPage(totalPages);
	        page = this.currentPage;
	      }
	
	      return page;
	    },
	    handleScroll: function handleScroll(extendMode, page) {
	      var _this3 = this;
	
	      _vue2.default.nextTick(function () {
	
	        var markedEl = _this3.markMessage(false);
	
	        if (!extendMode && !markedEl) {
	          _this3.scrollEl(container, container.scrollHeight - currentWinHeight + (0, _utils.elOffsetTop)(container) - 1);
	        } else if (extendMode === 'top') {
	          var firstEl = (0, _utils.getEl)(scrollPages[page + 1].first);
	          _this3.scrollToEl(firstEl, false);
	          _this3.scrollToEl(firstEl, true, -100);
	        } else if (extendMode === 'bottom') {
	          var prevPage = scrollPages[page - 1];
	          if (prevPage !== undefined) {
	            var lastEl = (0, _utils.getEl)(scrollPages[page - 1].last);
	            var newScrollPos = lastEl.offsetTop - currentWinHeight + (0, _utils.elOffsetTop)(container) + (0, _utils.elFullHeight)(lastEl) + 30;
	            _this3.scrollEl(container, newScrollPos, false);
	            _this3.scrollEl(container, newScrollPos, true, 100);
	          }
	        }
	
	        _this3.iterateScrollPages(function (key, scrollPage) {
	          var firstEl = (0, _utils.getEl)(scrollPage.first);
	          if (firstEl) scrollPage.firstOffsetTop = firstEl.offsetTop;else console.log('Warning: Missing firstEl #1', key, scrollPage);
	        });
	
	        _this3.onScroll(null, page);
	      });
	    },
	    scrollEl: function scrollEl(el, to) {
	      var animate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	      var offset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
	
	      if (animate) {
	        return (0, _utils.scrollTo)(el, to + offset);
	      }
	      return el.scrollTop = to + offset;
	    },
	    scrollToEl: function scrollToEl(el) {
	      var animate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	      var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	
	      if (animate) return (0, _utils.scrollTo)(container, el.offsetTop + offset);
	      return container.scrollTop = el.offsetTop + offset;
	    },
	    onScroll: function onScroll(e, page) {
	      page = page || this.currentPage;
	      if (container.scrollTop == container.scrollHeight - currentWinHeight + (0, _utils.elOffsetTop)(container)) {
	        this.onBottomScrollReach(page);
	      } else if (container.scrollTop == 0) {
	        this.onTopScrollReach(page);
	      }
	
	      var prevDiff = null,
	          activePage = null;
	      this.iterateScrollPages(function (key, scrollPage) {
	        var diff = container.scrollTop - scrollPage.firstOffsetTop;
	        if (diff >= 0 && (prevDiff === null || diff < prevDiff)) {
	          activePage = key;
	        }
	        prevDiff = diff;
	      });
	      if (activePage) this.setCurrentPage(activePage);
	    },
	    onTopScrollReach: function onTopScrollReach(page) {
	      if (page < 2) return;
	      this.changePage(page - 1, 'top');
	    },
	    onBottomScrollReach: function onBottomScrollReach(page) {
	      if (page === this.lastPage) return;
	      this.changePage(page + 1, 'bottom');
	    },
	    trackScroll: function trackScroll() {
	      if (scrollThrottle) return;
	      scrollThrottle = (0, _throttle2.default)(this.onScroll, 100);
	      container.addEventListener('scroll', scrollThrottle);
	    },
	    trackResize: function trackResize() {
	      if (resizeThrottle) return;
	      resizeThrottle = (0, _throttle2.default)(this.onResize, 250);
	      window.addEventListener('resize', resizeThrottle);
	    },
	    onResize: function onResize() {
	      currentWinHeight = (0, _utils.winHeight)();
	    },
	    stopTrackScroll: function stopTrackScroll() {
	      if (!scrollThrottle) return;
	      scrollThrottle.cancel();
	      container.removeEventListener('scroll', scrollThrottle);
	      scrollThrottle = null;
	    },
	    stopTrackResize: function stopTrackResize() {
	      if (!resizeThrottle) return;
	      resizeThrottle.cancel();
	      window.removeEventListener('resize', resizeThrottle);
	      resizeThrottle = null;
	    },
	    getMessageUrl: function getMessageUrl(m) {
	      var _this4 = this;
	
	      if (!this.search) {
	        var routeObj = {
	          name: 'channel_message',
	          params: { channel_name: this.channel.name, page: m.page, id: m.ts_id }
	        };
	        this.$router.push(routeObj);
	        return;
	      }
	
	      this.targetMessageId = m.ts_id;
	      this.targetMessageIdLoading = m.ts_id;
	      this.targetMessageError = null;
	      var channelName = this.channelIDsToName[m.channel];
	      if (!channelName) {
	        this.targetMessageIdLoading = null;
	        this.targetMessageError = 'Message channel is not available anymore (ID: ' + m.channel + ')';
	        return;
	      }
	
	      _services2.default.getMessages(this.team.team_id, m.channel, 0, undefined, null, null, m.ts_id).then(function (response) {
	        _this4.lastPage = 0;
	        _this4.currentPage = 0;
	        var messagesBefore = response.data.total;
	        _this4.getMessages(null, 1, m.channel, m.ts_id, messagesBefore);
	      }).catch(this.onError);
	    },
	    formatMessages: function formatMessages(messages, page) {
	      if (!messages.length) return [];
	
	      messages.reverse();
	      var msg = void 0,
	          i = void 0,
	          prev = void 0,
	          total = messages.length;
	
	      for (i = 0; i < total; i++) {
	        msg = messages[i];
	
	        msg.page = page;
	        msg.subtype = msg.subtype || '';
	        this.formatMessageUser(msg);
	        this.formatMessageDate(msg);
	        this.formatMessageText(msg.text, msg);
	        this.formatMessageAttachments(msg);
	        this.formatMessageDateSeparators(msg, prev, page == this.lastPage && i == total - 1);
	        prev = msg;
	      }
	      return messages;
	    },
	    formatMessageDate: function formatMessageDate(msg) {
	      msg.ts_id = msg.ts.replace('.', '');
	      msg.date = new Date(parseInt(msg.ts * 1000));
	      msg.date_str = (0, _utils.formatDate)(msg.date);
	    },
	    formatMessageText: function formatMessageText(text) {
	      var _this5 = this;
	
	      var msg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	      if (!text) return;
	
	      text = text.replace(/<(.*?)>/g, function (match, contents) {
	        var url = void 0,
	            url_name = void 0,
	            user = void 0;
	        if (contents.indexOf('|') !== -1) {
	          url = contents.split('|');
	          url_name = url[1];
	          url = url[0];
	        } else {
	          url = url_name = contents;
	        }
	
	        if (url_name.indexOf('@') === 0) {
	          user = _this5.users[url_name.substring(1)];
	          if (!user) {
	            return url_name;
	          }
	          url_name = '@' + user.name;
	        }
	        return '<a href="' + url + '" target="_bank">' + url_name + '</a>';
	      });
	
	      text = text.replace(/\[hl\](.*?)\[\/hl\]/g, function (match, contents) {
	        return '<em class="hl">' + contents + '</em>';
	      });
	
	      text = text.replace(/```([\s\S]*?)```/g, function (match, contents) {
	        return '<pre>' + contents + '</pre>';
	      });
	
	      text = text.replace(/`([\s\S]*?)`/g, function (match, contents) {
	        return '<code>' + contents + '</code>';
	      });
	
	      text = _nodeEmoji2.default.emojify(text);
	
	      if (msg) msg.text = text;
	
	      return text;
	    },
	    formatMessageUser: function formatMessageUser(msg) {
	      var user = this.users[msg.user],
	          defaultAvatar = {
	        image_48: 'https://i1.wp.com/slack.global.ssl.fastly.net/66f9/img/avatars/ava_0010-48.png'
	      },
	          username = void 0;
	      if (msg.username) {
	        username = this.formatMessageUsername(msg.username);
	        msg.user = {
	          name: username,
	          firstLetter: username.substring(0, 1)
	        };
	      } else if (msg.user && user) {
	        msg.user = user;
	      } else if (msg.user && !user) {
	        msg.user = { name: 'Unknown' };
	      } else if (msg.bot_id) {
	        msg.user = { name: 'bot' };
	      } else {
	        msg.user = { name: 'Unknown' };
	      }
	      if (!msg.user.profile) {
	        msg.user.profile = defaultAvatar;
	      }
	    },
	    formatMessageUsername: function formatMessageUsername(username) {
	      username = username.replace(/<(.*?)>/g, function (match, contents) {
	        if (contents.indexOf('|') !== -1) {
	          if (contents.indexOf('|') !== -1) {
	            return contents.split('|')[1];
	          }
	        }
	      });
	      return username;
	    },
	    formatMessageAttachments: function formatMessageAttachments(msg) {
	      if (!msg.attachments || !msg.attachments.length) return;
	      msg.text = msg.text || '';
	      var att_text = '',
	          i = void 0,
	          len = msg.attachments.length,
	          att = void 0,
	          text = void 0;
	      for (i = 0; i < len; i++) {
	        att = msg.attachments[i];
	        text = att.text || att.fallback;
	        text = this.formatMessageText(text);
	        att_text += '<div class="msg-attachment" style="border-left-color: #' + att.color + '">' + text + '</div>';
	      }
	      msg.text = msg.text + att_text;
	    },
	    formatMessageDateSeparators: function formatMessageDateSeparators(msg, prev, isLast) {
	      msg.isLast = isLast;
	
	      if (!prev || msg.date.getDate() !== prev.date.getDate()) {
	        msg.date_separator = (0, _utils.formatDate)(msg.date, true);
	      }
	
	      if (!prev) return;
	
	      if (!msg.date_separator && msg.user.profile && prev.user.profile && msg.user.profile.image_48 == prev.user.profile.image_48 && msg.user.name == prev.user.name) {
	        if (prev.date - msg.date < 5 * 60 * 1000) {
	          msg.same_user = true;
	        }
	      }
	    }
	  }
	};

/***/ }),

/***/ 105:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(27);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _utils = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      'popStateListening': false
	    };
	  },
	
	  methods: {
	    turn: function turn(page) {
	      var _this = this;
	
	      if (this.urlSync) {
	        var url = window.location.href,
	            params = (0, _utils.queryParams)(url),
	            state = { 'page': page };
	        if (!this.popStateListening) {
	          this.popStateListening = true;
	          window.addEventListener("popstate", function () {
	            _this.$emit('turn', window.history.state.page);
	          });
	        }
	        if (!window.history.state) {
	          window.history.replaceState({ 'page': this.currentPage }, '', url);
	        }
	        if (!params.length) {
	          window.history.pushState(state, '', url + '?' + this.pageName + '=' + page);
	        } else if (params[this.pageName]) {
	          window.history.pushState(state, '', url.replace(new RegExp('(' + this.pageName + '=)\\d+'), '$1' + page));
	        } else {
	          window.history.pushState(state, '', url + '&' + this.pageName + '=' + page);
	        }
	      }
	      this.$emit('turn', page);
	    },
	    prev: function prev() {
	      this.turn(this.currentPage - 1);
	    },
	    next: function next() {
	      this.turn(this.currentPage + 1);
	    },
	    isActive: function isActive(n) {
	      return this.currentPage == n;
	    }
	  },
	  props: {
	    side: {
	      type: Number,
	      default: 1
	    },
	    centerSide: {
	      type: Number,
	      default: 1
	    },
	    lastPage: {
	      type: Number,
	      required: true
	    },
	    currentPage: {
	      type: Number,
	      required: true
	    },
	    pageName: {
	      type: String,
	      default: 'page'
	    },
	    prevText: {
	      type: String,
	      default: '«'
	    },
	    nextText: {
	      type: String,
	      default: '»'
	    },
	    urlSync: {
	      type: Boolean,
	      default: false
	    },
	    cssClass: {
	      type: String,
	      default: null
	    }
	  },
	  computed: {
	    showCount: function showCount() {
	      return Math.min(this.lastPage, (this.centerSide + this.side) * 2 + 1);
	    },
	    halfCenterCount: function halfCenterCount() {
	      return parseInt((this.showCount - this.side * 2) / 2);
	    },
	    headEnd: function headEnd() {
	      return Math.min(this.lastPage, this.side);
	    },
	    tailShowCount: function tailShowCount() {
	      return Math.min(this.side, Math.max(this.lastPage - this.side, 0));
	    },
	    tailOffset: function tailOffset() {
	      return this.lastPage - this.tailShowCount;
	    },
	    headEllipsis: function headEllipsis() {
	      return this.lastPage > this.showCount && this.currentPage > this.side + this.halfCenterCount + 1;
	    },
	    tailEllipsis: function tailEllipsis() {
	      return this.lastPage > this.showCount && this.currentPage < this.lastPage - this.halfCenterCount - this.side;
	    },
	    centerCount: function centerCount() {
	      return this.lastPage > this.side * 2 ? this.lastPage <= this.showCount ? this.lastPage - this.side * 2 : this.showCount - this.side * 2 : 0;
	    },
	    centerOffset: function centerOffset() {
	      return !this.tailEllipsis ? this.lastPage - this.showCount + this.side : this.headEllipsis ? this.currentPage - this.halfCenterCount - 1 : this.side;
	    },
	    activePrev: function activePrev() {
	      return this.currentPage > 1;
	    },
	    activeNext: function activeNext() {
	      return this.currentPage < this.lastPage;
	    }
	  }
	};

/***/ }),

/***/ 106:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(29);
	
	var _orderBy = __webpack_require__(235);
	
	var _orderBy2 = _interopRequireDefault(_orderBy);
	
	var _throttle = __webpack_require__(80);
	
	var _throttle2 = _interopRequireDefault(_throttle);
	
	var _event = __webpack_require__(51);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var searchForm = void 0,
	    channelsList = void 0,
	    sepH2 = void 0,
	    topShadow = void 0,
	    bottomShadow = void 0,
	    topShadowHeight = void 0,
	    bottomShadowHeight = void 0,
	    searchInterval = void 0;
	
	_event.event.init();
	
	exports.default = {
	  props: ['team', 'channels'],
	  data: function data() {
	    return {
	      msg: '',
	      search: null,
	      channelAggs: null,
	      areFilteredChannels: null,
	      channelAggsForQuery: null,
	      search_query: this.$route.params.search_query || null,
	      activeFilter: true
	    };
	  },
	
	  computed: {
	    filteredChannels: function filteredChannels() {
	      var _this = this;
	
	      var channels = (0, _orderBy2.default)(this.channels.filter(function (channel) {
	        return !_this.activeFilter || _this.activeFilter && !channel.is_archived;
	      }), 'name');
	
	      var channelsWithResults = [];
	      this.areFilteredChannels = false;
	      if (this.channelAggs && this.search_query && this.search_query == this.channelAggsForQuery) {
	        var _loop = function _loop(key) {
	          if (_this.channelAggs.hasOwnProperty(key)) {
	            _this.channels.forEach(function (channel) {
	              if (channel.channel_id == key) {
	                _this.areFilteredChannels = true;
	                channel.results = _this.channelAggs[key];
	                channelsWithResults.push(channel);
	              }
	            });
	          }
	        };
	
	        for (var key in this.channelAggs) {
	          _loop(key);
	        }
	        channels = (0, _orderBy2.default)(channelsWithResults, 'results', 'desc');
	      } else {
	        this.channels.forEach(function (channel) {
	          delete channel.results;
	        });
	      }
	
	      return channels;
	    }
	  },
	  watch: {
	    $route: function $route(route, oldRoute) {
	      this.onRouteChange(route, oldRoute);
	    }
	  },
	  mounted: function mounted() {
	    var _this2 = this;
	
	    searchForm = (0, _utils.getEl)('searchForm');
	    channelsList = (0, _utils.getEl)('channelsList');
	    sepH2 = (0, _utils.getEl)('sepH2');
	    topShadow = (0, _utils.getEl)('topShadow');
	    bottomShadow = (0, _utils.getEl)('bottomShadow');
	
	    this.onResize();
	    window.addEventListener('resize', (0, _throttle2.default)(this.onResize, 200), false);
	
	    this.handleShadow();
	    this.onRouteChange(this.$route, null, true);
	
	    _event.event.on('channelAggs', function (aggs, searchQuery) {
	      _this2.channelAggs = aggs;
	      _this2.channelAggsForQuery = searchQuery;
	    });
	  },
	
	
	  methods: {
	    onRouteChange: function onRouteChange(route, oldRoute) {
	      var byMount = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	      if (route.name.indexOf('channel_search') === 0) {
	        if (byMount || this.search_query !== route.params.search) {
	          this.search_query = route.params.search;
	        }
	      } else if (this.search || this.search_query) {
	        this.search = this.search_query = null;
	      }
	    },
	    performSearch: function performSearch() {
	      var newSearch = this.search_query ? { query: this.search_query } : null;
	      if (newSearch != this.search) this.$router.push({ name: 'channel_search', params: { channel_name: '-', search: this.search_query } });
	      this.search = newSearch;
	    },
	    resetSearch: function resetSearch() {
	      this.search_query = null;
	      this.search = null;
	      this.$router.push(this.$route.params.channel_name && this.$route.params.channel_name !== '-' ? {
	        name: 'channel',
	        params: this.$route.params.channel_name
	      } : { name: 'home' });
	    },
	    onResize: function onResize() {
	      var available = (0, _utils.winHeight)() - (0, _utils.elOffsetTop)(searchForm) - (0, _utils.elHeight)(searchForm) - (0, _utils.elFullHeight)(sepH2);
	      channelsList.style.height = Math.floor(available) + 'px';
	    },
	    handleShadow: function handleShadow() {
	      topShadowHeight = topShadow.clientHeight;
	      bottomShadowHeight = bottomShadow.clientHeight;
	      this.onChannelsScroll();
	      channelsList.addEventListener('scroll', (0, _throttle2.default)(this.onChannelsScroll, 100), false);
	    },
	    onChannelsScroll: function onChannelsScroll() {
	      var scrollTop = channelsList.scrollTop,
	          scrollBottom = channelsList.scrollHeight - scrollTop - channelsList.clientHeight,
	          rollingShadowOffsetTop = 0,
	          rollingShadowOffsetBottom = 0;
	
	      if (scrollTop < topShadowHeight) {
	        rollingShadowOffsetTop = (topShadowHeight - scrollTop) * -1;
	      }
	      if (scrollBottom < bottomShadowHeight) {
	        rollingShadowOffsetBottom = (bottomShadowHeight - scrollBottom) * -1;
	      }
	
	      topShadow.style.top = rollingShadowOffsetTop + 'px';
	      bottomShadow.style.bottom = rollingShadowOffsetBottom + 'px';
	    }
	  }
	
	};

/***/ }),

/***/ 107:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: ['team'],
	  data: function data() {
	    return {
	      msg: ''
	    };
	  },
	
	  methods: {
	    toggleMenu: function toggleMenu() {
	      this.$emit('toggleMenu');
	    }
	  }
	};

/***/ }),

/***/ 144:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 145:
/***/ (function(module, exports) {

	module.exports = {"100":"💯","1234":"🔢","umbrella_with_rain_drops":"☔","coffee":"☕","aries":"♈","taurus":"♉","sagittarius":"♐","capricorn":"♑","aquarius":"♒","pisces":"♓","anchor":"⚓","white_check_mark":"✅","sparkles":"✨","question":"❓","grey_question":"❔","grey_exclamation":"❕","exclamation":"❗","heavy_exclamation_mark":"❗","heavy_plus_sign":"➕","heavy_minus_sign":"➖","heavy_division_sign":"➗","hash":"#️⃣","keycap_star":"*️⃣","zero":"0️⃣","one":"1️⃣","two":"2️⃣","three":"3️⃣","four":"4️⃣","five":"5️⃣","six":"6️⃣","seven":"7️⃣","eight":"8️⃣","nine":"9️⃣","copyright":"©️","registered":"®️","mahjong":"🀄","black_joker":"🃏","a":"🅰️","b":"🅱️","o2":"🅾️","parking":"🅿️","ab":"🆎","cl":"🆑","cool":"🆒","free":"🆓","id":"🆔","new":"🆕","ng":"🆖","ok":"🆗","sos":"🆘","up":"🆙","vs":"🆚","flag-ac":"🇦🇨","flag-ad":"🇦🇩","flag-ae":"🇦🇪","flag-af":"🇦🇫","flag-ag":"🇦🇬","flag-ai":"🇦🇮","flag-al":"🇦🇱","flag-am":"🇦🇲","flag-ao":"🇦🇴","flag-aq":"🇦🇶","flag-ar":"🇦🇷","flag-as":"🇦🇸","flag-at":"🇦🇹","flag-au":"🇦🇺","flag-aw":"🇦🇼","flag-ax":"🇦🇽","flag-az":"🇦🇿","flag-ba":"🇧🇦","flag-bb":"🇧🇧","flag-bd":"🇧🇩","flag-be":"🇧🇪","flag-bf":"🇧🇫","flag-bg":"🇧🇬","flag-bh":"🇧🇭","flag-bi":"🇧🇮","flag-bj":"🇧🇯","flag-bl":"🇧🇱","flag-bm":"🇧🇲","flag-bn":"🇧🇳","flag-bo":"🇧🇴","flag-bq":"🇧🇶","flag-br":"🇧🇷","flag-bs":"🇧🇸","flag-bt":"🇧🇹","flag-bv":"🇧🇻","flag-bw":"🇧🇼","flag-by":"🇧🇾","flag-bz":"🇧🇿","flag-ca":"🇨🇦","flag-cc":"🇨🇨","flag-cd":"🇨🇩","flag-cf":"🇨🇫","flag-cg":"🇨🇬","flag-ch":"🇨🇭","flag-ci":"🇨🇮","flag-ck":"🇨🇰","flag-cl":"🇨🇱","flag-cm":"🇨🇲","cn":"🇨🇳","flag-cn":"🇨🇳","flag-co":"🇨🇴","flag-cp":"🇨🇵","flag-cr":"🇨🇷","flag-cu":"🇨🇺","flag-cv":"🇨🇻","flag-cw":"🇨🇼","flag-cx":"🇨🇽","flag-cy":"🇨🇾","flag-cz":"🇨🇿","de":"🇩🇪","flag-de":"🇩🇪","flag-dg":"🇩🇬","flag-dj":"🇩🇯","flag-dk":"🇩🇰","flag-dm":"🇩🇲","flag-do":"🇩🇴","flag-dz":"🇩🇿","flag-ea":"🇪🇦","flag-ec":"🇪🇨","flag-ee":"🇪🇪","flag-eg":"🇪🇬","flag-eh":"🇪🇭","flag-er":"🇪🇷","es":"🇪🇸","flag-es":"🇪🇸","flag-et":"🇪🇹","flag-eu":"🇪🇺","flag-fi":"🇫🇮","flag-fj":"🇫🇯","flag-fk":"🇫🇰","flag-fm":"🇫🇲","flag-fo":"🇫🇴","fr":"🇫🇷","flag-fr":"🇫🇷","flag-ga":"🇬🇦","gb":"🇬🇧","uk":"🇬🇧","flag-gb":"🇬🇧","flag-gd":"🇬🇩","flag-ge":"🇬🇪","flag-gf":"🇬🇫","flag-gg":"🇬🇬","flag-gh":"🇬🇭","flag-gi":"🇬🇮","flag-gl":"🇬🇱","flag-gm":"🇬🇲","flag-gn":"🇬🇳","flag-gp":"🇬🇵","flag-gq":"🇬🇶","flag-gr":"🇬🇷","flag-gs":"🇬🇸","flag-gt":"🇬🇹","flag-gu":"🇬🇺","flag-gw":"🇬🇼","flag-gy":"🇬🇾","flag-hk":"🇭🇰","flag-hm":"🇭🇲","flag-hn":"🇭🇳","flag-hr":"🇭🇷","flag-ht":"🇭🇹","flag-hu":"🇭🇺","flag-ic":"🇮🇨","flag-id":"🇮🇩","flag-ie":"🇮🇪","flag-il":"🇮🇱","flag-im":"🇮🇲","flag-in":"🇮🇳","flag-io":"🇮🇴","flag-iq":"🇮🇶","flag-ir":"🇮🇷","flag-is":"🇮🇸","it":"🇮🇹","flag-it":"🇮🇹","flag-je":"🇯🇪","flag-jm":"🇯🇲","flag-jo":"🇯🇴","jp":"🇯🇵","flag-jp":"🇯🇵","flag-ke":"🇰🇪","flag-kg":"🇰🇬","flag-kh":"🇰🇭","flag-ki":"🇰🇮","flag-km":"🇰🇲","flag-kn":"🇰🇳","flag-kp":"🇰🇵","kr":"🇰🇷","flag-kr":"🇰🇷","flag-kw":"🇰🇼","flag-ky":"🇰🇾","flag-kz":"🇰🇿","flag-la":"🇱🇦","flag-lb":"🇱🇧","flag-lc":"🇱🇨","flag-li":"🇱🇮","flag-lk":"🇱🇰","flag-lr":"🇱🇷","flag-ls":"🇱🇸","flag-lt":"🇱🇹","flag-lu":"🇱🇺","flag-lv":"🇱🇻","flag-ly":"🇱🇾","flag-ma":"🇲🇦","flag-mc":"🇲🇨","flag-md":"🇲🇩","flag-me":"🇲🇪","flag-mf":"🇲🇫","flag-mg":"🇲🇬","flag-mh":"🇲🇭","flag-mk":"🇲🇰","flag-ml":"🇲🇱","flag-mm":"🇲🇲","flag-mn":"🇲🇳","flag-mo":"🇲🇴","flag-mp":"🇲🇵","flag-mq":"🇲🇶","flag-mr":"🇲🇷","flag-ms":"🇲🇸","flag-mt":"🇲🇹","flag-mu":"🇲🇺","flag-mv":"🇲🇻","flag-mw":"🇲🇼","flag-mx":"🇲🇽","flag-my":"🇲🇾","flag-mz":"🇲🇿","flag-na":"🇳🇦","flag-nc":"🇳🇨","flag-ne":"🇳🇪","flag-nf":"🇳🇫","flag-ng":"🇳🇬","flag-ni":"🇳🇮","flag-nl":"🇳🇱","flag-no":"🇳🇴","flag-np":"🇳🇵","flag-nr":"🇳🇷","flag-nu":"🇳🇺","flag-nz":"🇳🇿","flag-om":"🇴🇲","flag-pa":"🇵🇦","flag-pe":"🇵🇪","flag-pf":"🇵🇫","flag-pg":"🇵🇬","flag-ph":"🇵🇭","flag-pk":"🇵🇰","flag-pl":"🇵🇱","flag-pm":"🇵🇲","flag-pn":"🇵🇳","flag-pr":"🇵🇷","flag-ps":"🇵🇸","flag-pt":"🇵🇹","flag-pw":"🇵🇼","flag-py":"🇵🇾","flag-qa":"🇶🇦","flag-re":"🇷🇪","flag-ro":"🇷🇴","flag-rs":"🇷🇸","ru":"🇷🇺","flag-ru":"🇷🇺","flag-rw":"🇷🇼","flag-sa":"🇸🇦","flag-sb":"🇸🇧","flag-sc":"🇸🇨","flag-sd":"🇸🇩","flag-se":"🇸🇪","flag-sg":"🇸🇬","flag-sh":"🇸🇭","flag-si":"🇸🇮","flag-sj":"🇸🇯","flag-sk":"🇸🇰","flag-sl":"🇸🇱","flag-sm":"🇸🇲","flag-sn":"🇸🇳","flag-so":"🇸🇴","flag-sr":"🇸🇷","flag-ss":"🇸🇸","flag-st":"🇸🇹","flag-sv":"🇸🇻","flag-sx":"🇸🇽","flag-sy":"🇸🇾","flag-sz":"🇸🇿","flag-ta":"🇹🇦","flag-tc":"🇹🇨","flag-td":"🇹🇩","flag-tf":"🇹🇫","flag-tg":"🇹🇬","flag-th":"🇹🇭","flag-tj":"🇹🇯","flag-tk":"🇹🇰","flag-tl":"🇹🇱","flag-tm":"🇹🇲","flag-tn":"🇹🇳","flag-to":"🇹🇴","flag-tr":"🇹🇷","flag-tt":"🇹🇹","flag-tv":"🇹🇻","flag-tw":"🇹🇼","flag-tz":"🇹🇿","flag-ua":"🇺🇦","flag-ug":"🇺🇬","flag-um":"🇺🇲","flag-un":"🇺🇳","us":"🇺🇸","flag-us":"🇺🇸","flag-uy":"🇺🇾","flag-uz":"🇺🇿","flag-va":"🇻🇦","flag-vc":"🇻🇨","flag-ve":"🇻🇪","flag-vg":"🇻🇬","flag-vi":"🇻🇮","flag-vn":"🇻🇳","flag-vu":"🇻🇺","flag-wf":"🇼🇫","flag-ws":"🇼🇸","flag-xk":"🇽🇰","flag-ye":"🇾🇪","flag-yt":"🇾🇹","flag-za":"🇿🇦","flag-zm":"🇿🇲","flag-zw":"🇿🇼","koko":"🈁","sa":"🈂️","u7121":"🈚","u6307":"🈯","u7981":"🈲","u7a7a":"🈳","u5408":"🈴","u6e80":"🈵","u6709":"🈶","u6708":"🈷️","u7533":"🈸","u5272":"🈹","u55b6":"🈺","ideograph_advantage":"🉐","accept":"🉑","cyclone":"🌀","foggy":"🌁","closed_umbrella":"🌂","night_with_stars":"🌃","sunrise_over_mountains":"🌄","sunrise":"🌅","city_sunset":"🌆","city_sunrise":"🌇","rainbow":"🌈","bridge_at_night":"🌉","ocean":"🌊","volcano":"🌋","milky_way":"🌌","earth_africa":"🌍","earth_americas":"🌎","earth_asia":"🌏","globe_with_meridians":"🌐","new_moon":"🌑","waxing_crescent_moon":"🌒","first_quarter_moon":"🌓","moon":"🌔","waxing_gibbous_moon":"🌔","full_moon":"🌕","waning_gibbous_moon":"🌖","last_quarter_moon":"🌗","waning_crescent_moon":"🌘","crescent_moon":"🌙","new_moon_with_face":"🌚","first_quarter_moon_with_face":"🌛","last_quarter_moon_with_face":"🌜","full_moon_with_face":"🌝","sun_with_face":"🌞","star2":"🌟","stars":"🌠","thermometer":"🌡️","mostly_sunny":"🌤️","sun_small_cloud":"🌤️","barely_sunny":"🌥️","sun_behind_cloud":"🌥️","partly_sunny_rain":"🌦️","sun_behind_rain_cloud":"🌦️","rain_cloud":"🌧️","snow_cloud":"🌨️","lightning":"🌩️","lightning_cloud":"🌩️","tornado":"🌪️","tornado_cloud":"🌪️","fog":"🌫️","wind_blowing_face":"🌬️","hotdog":"🌭","taco":"🌮","burrito":"🌯","chestnut":"🌰","seedling":"🌱","evergreen_tree":"🌲","deciduous_tree":"🌳","palm_tree":"🌴","cactus":"🌵","hot_pepper":"🌶️","tulip":"🌷","cherry_blossom":"🌸","rose":"🌹","hibiscus":"🌺","sunflower":"🌻","blossom":"🌼","corn":"🌽","ear_of_rice":"🌾","herb":"🌿","four_leaf_clover":"🍀","maple_leaf":"🍁","fallen_leaf":"🍂","leaves":"🍃","mushroom":"🍄","tomato":"🍅","eggplant":"🍆","grapes":"🍇","melon":"🍈","watermelon":"🍉","tangerine":"🍊","lemon":"🍋","banana":"🍌","pineapple":"🍍","apple":"🍎","green_apple":"🍏","pear":"🍐","peach":"🍑","cherries":"🍒","strawberry":"🍓","hamburger":"🍔","pizza":"🍕","meat_on_bone":"🍖","poultry_leg":"🍗","rice_cracker":"🍘","rice_ball":"🍙","rice":"🍚","curry":"🍛","ramen":"🍜","spaghetti":"🍝","bread":"🍞","fries":"🍟","sweet_potato":"🍠","dango":"🍡","oden":"🍢","sushi":"🍣","fried_shrimp":"🍤","fish_cake":"🍥","icecream":"🍦","shaved_ice":"🍧","ice_cream":"🍨","doughnut":"🍩","cookie":"🍪","chocolate_bar":"🍫","candy":"🍬","lollipop":"🍭","custard":"🍮","honey_pot":"🍯","cake":"🍰","bento":"🍱","stew":"🍲","fried_egg":"🍳","cooking":"🍳","fork_and_knife":"🍴","tea":"🍵","sake":"🍶","wine_glass":"🍷","cocktail":"🍸","tropical_drink":"🍹","beer":"🍺","beers":"🍻","baby_bottle":"🍼","knife_fork_plate":"🍽️","champagne":"🍾","popcorn":"🍿","ribbon":"🎀","gift":"🎁","birthday":"🎂","jack_o_lantern":"🎃","christmas_tree":"🎄","santa":"🎅","fireworks":"🎆","sparkler":"🎇","balloon":"🎈","tada":"🎉","confetti_ball":"🎊","tanabata_tree":"🎋","crossed_flags":"🎌","bamboo":"🎍","dolls":"🎎","flags":"🎏","wind_chime":"🎐","rice_scene":"🎑","school_satchel":"🎒","mortar_board":"🎓","medal":"🎖️","reminder_ribbon":"🎗️","studio_microphone":"🎙️","level_slider":"🎚️","control_knobs":"🎛️","film_frames":"🎞️","admission_tickets":"🎟️","carousel_horse":"🎠","ferris_wheel":"🎡","roller_coaster":"🎢","fishing_pole_and_fish":"🎣","microphone":"🎤","movie_camera":"🎥","cinema":"🎦","headphones":"🎧","art":"🎨","tophat":"🎩","circus_tent":"🎪","ticket":"🎫","clapper":"🎬","performing_arts":"🎭","video_game":"🎮","dart":"🎯","slot_machine":"🎰","8ball":"🎱","game_die":"🎲","bowling":"🎳","flower_playing_cards":"🎴","musical_note":"🎵","notes":"🎶","saxophone":"🎷","guitar":"🎸","musical_keyboard":"🎹","trumpet":"🎺","violin":"🎻","musical_score":"🎼","running_shirt_with_sash":"🎽","tennis":"🎾","ski":"🎿","basketball":"🏀","checkered_flag":"🏁","snowboarder":"🏂","woman-running":"🏃‍♀️","man-running":"🏃‍♂️","runner":"🏃‍♂️","running":"🏃‍♂️","woman-surfing":"🏄‍♀️","man-surfing":"🏄‍♂️","surfer":"🏄‍♂️","sports_medal":"🏅","trophy":"🏆","horse_racing":"🏇","football":"🏈","rugby_football":"🏉","woman-swimming":"🏊‍♀️","man-swimming":"🏊‍♂️","swimmer":"🏊‍♂️","woman-lifting-weights":"🏋️‍♀️","man-lifting-weights":"🏋️‍♂️","weight_lifter":"🏋️‍♂️","woman-golfing":"🏌️‍♀️","man-golfing":"🏌️‍♂️","golfer":"🏌️‍♂️","racing_motorcycle":"🏍️","racing_car":"🏎️","cricket_bat_and_ball":"🏏","volleyball":"🏐","field_hockey_stick_and_ball":"🏑","ice_hockey_stick_and_puck":"🏒","table_tennis_paddle_and_ball":"🏓","snow_capped_mountain":"🏔️","camping":"🏕️","beach_with_umbrella":"🏖️","building_construction":"🏗️","house_buildings":"🏘️","cityscape":"🏙️","derelict_house_building":"🏚️","classical_building":"🏛️","desert":"🏜️","desert_island":"🏝️","national_park":"🏞️","stadium":"🏟️","house":"🏠","house_with_garden":"🏡","office":"🏢","post_office":"🏣","european_post_office":"🏤","hospital":"🏥","bank":"🏦","atm":"🏧","hotel":"🏨","love_hotel":"🏩","convenience_store":"🏪","school":"🏫","department_store":"🏬","factory":"🏭","izakaya_lantern":"🏮","lantern":"🏮","japanese_castle":"🏯","european_castle":"🏰","rainbow-flag":"🏳️‍🌈","waving_white_flag":"🏳️","flag-england":"🏴󠁧󠁢󠁥󠁮󠁧󠁿","flag-scotland":"🏴󠁧󠁢󠁳󠁣󠁴󠁿","flag-wales":"🏴󠁧󠁢󠁷󠁬󠁳󠁿","waving_black_flag":"🏴","rosette":"🏵️","label":"🏷️","badminton_racquet_and_shuttlecock":"🏸","bow_and_arrow":"🏹","amphora":"🏺","skin-tone-2":"🏻","skin-tone-3":"🏼","skin-tone-4":"🏽","skin-tone-5":"🏾","skin-tone-6":"🏿","rat":"🐀","mouse2":"🐁","ox":"🐂","water_buffalo":"🐃","cow2":"🐄","tiger2":"🐅","leopard":"🐆","rabbit2":"🐇","cat2":"🐈","dragon":"🐉","crocodile":"🐊","whale2":"🐋","snail":"🐌","snake":"🐍","racehorse":"🐎","ram":"🐏","goat":"🐐","sheep":"🐑","monkey":"🐒","rooster":"🐓","chicken":"🐔","dog2":"🐕","pig2":"🐖","boar":"🐗","elephant":"🐘","octopus":"🐙","shell":"🐚","bug":"🐛","ant":"🐜","bee":"🐝","honeybee":"🐝","beetle":"🐞","fish":"🐟","tropical_fish":"🐠","blowfish":"🐡","turtle":"🐢","hatching_chick":"🐣","baby_chick":"🐤","hatched_chick":"🐥","bird":"🐦","penguin":"🐧","koala":"🐨","poodle":"🐩","dromedary_camel":"🐪","camel":"🐫","dolphin":"🐬","flipper":"🐬","mouse":"🐭","cow":"🐮","tiger":"🐯","rabbit":"🐰","cat":"🐱","dragon_face":"🐲","whale":"🐳","horse":"🐴","monkey_face":"🐵","dog":"🐶","pig":"🐷","frog":"🐸","hamster":"🐹","wolf":"🐺","bear":"🐻","panda_face":"🐼","pig_nose":"🐽","feet":"🐾","paw_prints":"🐾","chipmunk":"🐿️","eyes":"👀","eye-in-speech-bubble":"👁️‍🗨️","eye":"👁️","ear":"👂","nose":"👃","lips":"👄","tongue":"👅","point_up_2":"👆","point_down":"👇","point_left":"👈","point_right":"👉","facepunch":"👊","punch":"👊","wave":"👋","ok_hand":"👌","+1":"👍","thumbsup":"👍","-1":"👎","thumbsdown":"👎","clap":"👏","open_hands":"👐","crown":"👑","womans_hat":"👒","eyeglasses":"👓","necktie":"👔","shirt":"👕","tshirt":"👕","jeans":"👖","dress":"👗","kimono":"👘","bikini":"👙","womans_clothes":"👚","purse":"👛","handbag":"👜","pouch":"👝","mans_shoe":"👞","shoe":"👞","athletic_shoe":"👟","high_heel":"👠","sandal":"👡","boot":"👢","footprints":"👣","bust_in_silhouette":"👤","busts_in_silhouette":"👥","boy":"👦","girl":"👧","male-farmer":"👨‍🌾","male-cook":"👨‍🍳","male-student":"👨‍🎓","male-singer":"👨‍🎤","male-artist":"👨‍🎨","male-teacher":"👨‍🏫","male-factory-worker":"👨‍🏭","man-boy-boy":"👨‍👦‍👦","man-boy":"👨‍👦","man-girl-boy":"👨‍👧‍👦","man-girl-girl":"👨‍👧‍👧","man-girl":"👨‍👧","man-man-boy":"👨‍👨‍👦","man-man-boy-boy":"👨‍👨‍👦‍👦","man-man-girl":"👨‍👨‍👧","man-man-girl-boy":"👨‍👨‍👧‍👦","man-man-girl-girl":"👨‍👨‍👧‍👧","man-woman-boy":"👨‍👩‍👦","family":"👨‍👩‍👦","man-woman-boy-boy":"👨‍👩‍👦‍👦","man-woman-girl":"👨‍👩‍👧","man-woman-girl-boy":"👨‍👩‍👧‍👦","man-woman-girl-girl":"👨‍👩‍👧‍👧","male-technologist":"👨‍💻","male-office-worker":"👨‍💼","male-mechanic":"👨‍🔧","male-scientist":"👨‍🔬","male-astronaut":"👨‍🚀","male-firefighter":"👨‍🚒","male-doctor":"👨‍⚕️","male-judge":"👨‍⚖️","male-pilot":"👨‍✈️","man-heart-man":"👨‍❤️‍👨","man-kiss-man":"👨‍❤️‍💋‍👨","man":"👨","female-farmer":"👩‍🌾","female-cook":"👩‍🍳","female-student":"👩‍🎓","female-singer":"👩‍🎤","female-artist":"👩‍🎨","female-teacher":"👩‍🏫","female-factory-worker":"👩‍🏭","woman-boy-boy":"👩‍👦‍👦","woman-boy":"👩‍👦","woman-girl-boy":"👩‍👧‍👦","woman-girl-girl":"👩‍👧‍👧","woman-girl":"👩‍👧","woman-woman-boy":"👩‍👩‍👦","woman-woman-boy-boy":"👩‍👩‍👦‍👦","woman-woman-girl":"👩‍👩‍👧","woman-woman-girl-boy":"👩‍👩‍👧‍👦","woman-woman-girl-girl":"👩‍👩‍👧‍👧","female-technologist":"👩‍💻","female-office-worker":"👩‍💼","female-mechanic":"👩‍🔧","female-scientist":"👩‍🔬","female-astronaut":"👩‍🚀","female-firefighter":"👩‍🚒","female-doctor":"👩‍⚕️","female-judge":"👩‍⚖️","female-pilot":"👩‍✈️","woman-heart-man":"👩‍❤️‍👨","couple_with_heart":"👩‍❤️‍👨","woman-heart-woman":"👩‍❤️‍👩","woman-kiss-man":"👩‍❤️‍💋‍👨","couplekiss":"👩‍❤️‍💋‍👨","woman-kiss-woman":"👩‍❤️‍💋‍👩","woman":"👩","couple":"👫","man_and_woman_holding_hands":"👫","two_men_holding_hands":"👬","two_women_holding_hands":"👭","female-police-officer":"👮‍♀️","male-police-officer":"👮‍♂️","cop":"👮‍♂️","woman-with-bunny-ears-partying":"👯‍♀️","dancers":"👯‍♀️","man-with-bunny-ears-partying":"👯‍♂️","bride_with_veil":"👰","blond-haired-woman":"👱‍♀️","blond-haired-man":"👱‍♂️","person_with_blond_hair":"👱‍♂️","man_with_gua_pi_mao":"👲","woman-wearing-turban":"👳‍♀️","man-wearing-turban":"👳‍♂️","man_with_turban":"👳‍♂️","older_man":"👴","older_woman":"👵","baby":"👶","female-construction-worker":"👷‍♀️","male-construction-worker":"👷‍♂️","construction_worker":"👷‍♂️","princess":"👸","japanese_ogre":"👹","japanese_goblin":"👺","ghost":"👻","angel":"👼","alien":"👽","space_invader":"👾","imp":"👿","skull":"💀","woman-tipping-hand":"💁‍♀️","information_desk_person":"💁‍♀️","man-tipping-hand":"💁‍♂️","female-guard":"💂‍♀️","male-guard":"💂‍♂️","guardsman":"💂‍♂️","dancer":"💃","lipstick":"💄","nail_care":"💅","woman-getting-massage":"💆‍♀️","massage":"💆‍♀️","man-getting-massage":"💆‍♂️","woman-getting-haircut":"💇‍♀️","haircut":"💇‍♀️","man-getting-haircut":"💇‍♂️","barber":"💈","syringe":"💉","pill":"💊","kiss":"💋","love_letter":"💌","ring":"💍","gem":"💎","bouquet":"💐","wedding":"💒","heartbeat":"💓","broken_heart":"💔","two_hearts":"💕","sparkling_heart":"💖","heartpulse":"💗","cupid":"💘","blue_heart":"💙","green_heart":"💚","yellow_heart":"💛","purple_heart":"💜","gift_heart":"💝","revolving_hearts":"💞","heart_decoration":"💟","diamond_shape_with_a_dot_inside":"💠","bulb":"💡","anger":"💢","bomb":"💣","zzz":"💤","boom":"💥","collision":"💥","sweat_drops":"💦","droplet":"💧","dash":"💨","hankey":"💩","poop":"💩","shit":"💩","muscle":"💪","dizzy":"💫","speech_balloon":"💬","thought_balloon":"💭","white_flower":"💮","moneybag":"💰","currency_exchange":"💱","heavy_dollar_sign":"💲","credit_card":"💳","yen":"💴","dollar":"💵","euro":"💶","pound":"💷","money_with_wings":"💸","chart":"💹","seat":"💺","computer":"💻","briefcase":"💼","minidisc":"💽","floppy_disk":"💾","cd":"💿","dvd":"📀","file_folder":"📁","open_file_folder":"📂","page_with_curl":"📃","page_facing_up":"📄","date":"📅","calendar":"📆","card_index":"📇","chart_with_upwards_trend":"📈","chart_with_downwards_trend":"📉","bar_chart":"📊","clipboard":"📋","pushpin":"📌","round_pushpin":"📍","paperclip":"📎","straight_ruler":"📏","triangular_ruler":"📐","bookmark_tabs":"📑","ledger":"📒","notebook":"📓","notebook_with_decorative_cover":"📔","closed_book":"📕","book":"📖","open_book":"📖","green_book":"📗","blue_book":"📘","orange_book":"📙","books":"📚","name_badge":"📛","scroll":"📜","memo":"📝","pencil":"📝","telephone_receiver":"📞","pager":"📟","fax":"📠","satellite_antenna":"📡","loudspeaker":"📢","mega":"📣","outbox_tray":"📤","inbox_tray":"📥","package":"📦","e-mail":"📧","incoming_envelope":"📨","envelope_with_arrow":"📩","mailbox_closed":"📪","mailbox":"📫","mailbox_with_mail":"📬","mailbox_with_no_mail":"📭","postbox":"📮","postal_horn":"📯","newspaper":"📰","iphone":"📱","calling":"📲","vibration_mode":"📳","mobile_phone_off":"📴","no_mobile_phones":"📵","signal_strength":"📶","camera":"📷","camera_with_flash":"📸","video_camera":"📹","tv":"📺","radio":"📻","vhs":"📼","film_projector":"📽️","prayer_beads":"📿","twisted_rightwards_arrows":"🔀","repeat":"🔁","repeat_one":"🔂","arrows_clockwise":"🔃","arrows_counterclockwise":"🔄","low_brightness":"🔅","high_brightness":"🔆","mute":"🔇","speaker":"🔈","sound":"🔉","loud_sound":"🔊","battery":"🔋","electric_plug":"🔌","mag":"🔍","mag_right":"🔎","lock_with_ink_pen":"🔏","closed_lock_with_key":"🔐","key":"🔑","lock":"🔒","unlock":"🔓","bell":"🔔","no_bell":"🔕","bookmark":"🔖","link":"🔗","radio_button":"🔘","back":"🔙","end":"🔚","on":"🔛","soon":"🔜","top":"🔝","underage":"🔞","keycap_ten":"🔟","capital_abcd":"🔠","abcd":"🔡","symbols":"🔣","abc":"🔤","fire":"🔥","flashlight":"🔦","wrench":"🔧","hammer":"🔨","nut_and_bolt":"🔩","hocho":"🔪","knife":"🔪","gun":"🔫","microscope":"🔬","telescope":"🔭","crystal_ball":"🔮","six_pointed_star":"🔯","beginner":"🔰","trident":"🔱","black_square_button":"🔲","white_square_button":"🔳","red_circle":"🔴","large_blue_circle":"🔵","large_orange_diamond":"🔶","large_blue_diamond":"🔷","small_orange_diamond":"🔸","small_blue_diamond":"🔹","small_red_triangle":"🔺","small_red_triangle_down":"🔻","arrow_up_small":"🔼","arrow_down_small":"🔽","om_symbol":"🕉️","dove_of_peace":"🕊️","kaaba":"🕋","mosque":"🕌","synagogue":"🕍","menorah_with_nine_branches":"🕎","clock1":"🕐","clock2":"🕑","clock3":"🕒","clock4":"🕓","clock5":"🕔","clock6":"🕕","clock7":"🕖","clock8":"🕗","clock9":"🕘","clock10":"🕙","clock11":"🕚","clock12":"🕛","clock130":"🕜","clock230":"🕝","clock330":"🕞","clock430":"🕟","clock530":"🕠","clock630":"🕡","clock730":"🕢","clock830":"🕣","clock930":"🕤","clock1030":"🕥","clock1130":"🕦","clock1230":"🕧","candle":"🕯️","mantelpiece_clock":"🕰️","hole":"🕳️","man_in_business_suit_levitating":"🕴️","female-detective":"🕵️‍♀️","male-detective":"🕵️‍♂️","sleuth_or_spy":"🕵️‍♂️","dark_sunglasses":"🕶️","spider":"🕷️","spider_web":"🕸️","joystick":"🕹️","man_dancing":"🕺","linked_paperclips":"🖇️","lower_left_ballpoint_pen":"🖊️","lower_left_fountain_pen":"🖋️","lower_left_paintbrush":"🖌️","lower_left_crayon":"🖍️","raised_hand_with_fingers_splayed":"🖐️","middle_finger":"🖕","reversed_hand_with_middle_finger_extended":"🖕","spock-hand":"🖖","black_heart":"🖤","desktop_computer":"🖥️","printer":"🖨️","three_button_mouse":"🖱️","trackball":"🖲️","frame_with_picture":"🖼️","card_index_dividers":"🗂️","card_file_box":"🗃️","file_cabinet":"🗄️","wastebasket":"🗑️","spiral_note_pad":"🗒️","spiral_calendar_pad":"🗓️","compression":"🗜️","old_key":"🗝️","rolled_up_newspaper":"🗞️","dagger_knife":"🗡️","speaking_head_in_silhouette":"🗣️","left_speech_bubble":"🗨️","right_anger_bubble":"🗯️","ballot_box_with_ballot":"🗳️","world_map":"🗺️","mount_fuji":"🗻","tokyo_tower":"🗼","statue_of_liberty":"🗽","japan":"🗾","moyai":"🗿","grinning":"😀","grin":"😁","joy":"😂","smiley":"😃","smile":"😄","sweat_smile":"😅","laughing":"😆","satisfied":"😆","innocent":"😇","smiling_imp":"😈","wink":"😉","blush":"😊","yum":"😋","relieved":"😌","heart_eyes":"😍","sunglasses":"😎","smirk":"😏","neutral_face":"😐","expressionless":"😑","unamused":"😒","sweat":"😓","pensive":"😔","confused":"😕","confounded":"😖","kissing":"😗","kissing_heart":"😘","kissing_smiling_eyes":"😙","kissing_closed_eyes":"😚","stuck_out_tongue":"😛","stuck_out_tongue_winking_eye":"😜","stuck_out_tongue_closed_eyes":"😝","disappointed":"😞","worried":"😟","angry":"😠","rage":"😡","cry":"😢","persevere":"😣","triumph":"😤","disappointed_relieved":"😥","frowning":"😦","anguished":"😧","fearful":"😨","weary":"😩","sleepy":"😪","tired_face":"😫","grimacing":"😬","sob":"😭","open_mouth":"😮","hushed":"😯","cold_sweat":"😰","scream":"😱","astonished":"😲","flushed":"😳","sleeping":"😴","dizzy_face":"😵","no_mouth":"😶","mask":"😷","smile_cat":"😸","joy_cat":"😹","smiley_cat":"😺","heart_eyes_cat":"😻","smirk_cat":"😼","kissing_cat":"😽","pouting_cat":"😾","crying_cat_face":"😿","scream_cat":"🙀","slightly_frowning_face":"🙁","slightly_smiling_face":"🙂","upside_down_face":"🙃","face_with_rolling_eyes":"🙄","woman-gesturing-no":"🙅‍♀️","no_good":"🙅‍♀️","man-gesturing-no":"🙅‍♂️","woman-gesturing-ok":"🙆‍♀️","ok_woman":"🙆‍♀️","man-gesturing-ok":"🙆‍♂️","woman-bowing":"🙇‍♀️","man-bowing":"🙇‍♂️","bow":"🙇‍♂️","see_no_evil":"🙈","hear_no_evil":"🙉","speak_no_evil":"🙊","woman-raising-hand":"🙋‍♀️","raising_hand":"🙋‍♀️","man-raising-hand":"🙋‍♂️","raised_hands":"🙌","woman-frowning":"🙍‍♀️","person_frowning":"🙍‍♀️","man-frowning":"🙍‍♂️","woman-pouting":"🙎‍♀️","person_with_pouting_face":"🙎‍♀️","man-pouting":"🙎‍♂️","pray":"🙏","rocket":"🚀","helicopter":"🚁","steam_locomotive":"🚂","railway_car":"🚃","bullettrain_side":"🚄","bullettrain_front":"🚅","train2":"🚆","metro":"🚇","light_rail":"🚈","station":"🚉","tram":"🚊","train":"🚋","bus":"🚌","oncoming_bus":"🚍","trolleybus":"🚎","busstop":"🚏","minibus":"🚐","ambulance":"🚑","fire_engine":"🚒","police_car":"🚓","oncoming_police_car":"🚔","taxi":"🚕","oncoming_taxi":"🚖","car":"🚗","red_car":"🚗","oncoming_automobile":"🚘","blue_car":"🚙","truck":"🚚","articulated_lorry":"🚛","tractor":"🚜","monorail":"🚝","mountain_railway":"🚞","suspension_railway":"🚟","mountain_cableway":"🚠","aerial_tramway":"🚡","ship":"🚢","woman-rowing-boat":"🚣‍♀️","man-rowing-boat":"🚣‍♂️","rowboat":"🚣‍♂️","speedboat":"🚤","traffic_light":"🚥","vertical_traffic_light":"🚦","construction":"🚧","rotating_light":"🚨","triangular_flag_on_post":"🚩","door":"🚪","no_entry_sign":"🚫","smoking":"🚬","no_smoking":"🚭","put_litter_in_its_place":"🚮","do_not_litter":"🚯","potable_water":"🚰","non-potable_water":"🚱","bike":"🚲","no_bicycles":"🚳","woman-biking":"🚴‍♀️","man-biking":"🚴‍♂️","bicyclist":"🚴‍♂️","woman-mountain-biking":"🚵‍♀️","man-mountain-biking":"🚵‍♂️","mountain_bicyclist":"🚵‍♂️","woman-walking":"🚶‍♀️","man-walking":"🚶‍♂️","walking":"🚶‍♂️","no_pedestrians":"🚷","children_crossing":"🚸","mens":"🚹","womens":"🚺","restroom":"🚻","baby_symbol":"🚼","toilet":"🚽","wc":"🚾","shower":"🚿","bath":"🛀","bathtub":"🛁","passport_control":"🛂","customs":"🛃","baggage_claim":"🛄","left_luggage":"🛅","couch_and_lamp":"🛋️","sleeping_accommodation":"🛌","shopping_bags":"🛍️","bellhop_bell":"🛎️","bed":"🛏️","place_of_worship":"🛐","octagonal_sign":"🛑","shopping_trolley":"🛒","hammer_and_wrench":"🛠️","shield":"🛡️","oil_drum":"🛢️","motorway":"🛣️","railway_track":"🛤️","motor_boat":"🛥️","small_airplane":"🛩️","airplane_departure":"🛫","airplane_arriving":"🛬","satellite":"🛰️","passenger_ship":"🛳️","scooter":"🛴","motor_scooter":"🛵","canoe":"🛶","sled":"🛷","flying_saucer":"🛸","zipper_mouth_face":"🤐","money_mouth_face":"🤑","face_with_thermometer":"🤒","nerd_face":"🤓","thinking_face":"🤔","face_with_head_bandage":"🤕","robot_face":"🤖","hugging_face":"🤗","the_horns":"🤘","sign_of_the_horns":"🤘","call_me_hand":"🤙","raised_back_of_hand":"🤚","left-facing_fist":"🤛","right-facing_fist":"🤜","handshake":"🤝","crossed_fingers":"🤞","hand_with_index_and_middle_fingers_crossed":"🤞","i_love_you_hand_sign":"🤟","face_with_cowboy_hat":"🤠","clown_face":"🤡","nauseated_face":"🤢","rolling_on_the_floor_laughing":"🤣","drooling_face":"🤤","lying_face":"🤥","woman-facepalming":"🤦‍♀️","man-facepalming":"🤦‍♂️","face_palm":"🤦","sneezing_face":"🤧","face_with_raised_eyebrow":"🤨","face_with_one_eyebrow_raised":"🤨","star-struck":"🤩","grinning_face_with_star_eyes":"🤩","zany_face":"🤪","grinning_face_with_one_large_and_one_small_eye":"🤪","shushing_face":"🤫","face_with_finger_covering_closed_lips":"🤫","face_with_symbols_on_mouth":"🤬","serious_face_with_symbols_covering_mouth":"🤬","face_with_hand_over_mouth":"🤭","smiling_face_with_smiling_eyes_and_hand_covering_mouth":"🤭","face_vomiting":"🤮","face_with_open_mouth_vomiting":"🤮","exploding_head":"🤯","shocked_face_with_exploding_head":"🤯","pregnant_woman":"🤰","breast-feeding":"🤱","palms_up_together":"🤲","selfie":"🤳","prince":"🤴","man_in_tuxedo":"🤵","mrs_claus":"🤶","mother_christmas":"🤶","woman-shrugging":"🤷‍♀️","man-shrugging":"🤷‍♂️","shrug":"🤷","woman-cartwheeling":"🤸‍♀️","man-cartwheeling":"🤸‍♂️","person_doing_cartwheel":"🤸","woman-juggling":"🤹‍♀️","man-juggling":"🤹‍♂️","juggling":"🤹","fencer":"🤺","woman-wrestling":"🤼‍♀️","man-wrestling":"🤼‍♂️","wrestlers":"🤼","woman-playing-water-polo":"🤽‍♀️","man-playing-water-polo":"🤽‍♂️","water_polo":"🤽","woman-playing-handball":"🤾‍♀️","man-playing-handball":"🤾‍♂️","handball":"🤾","wilted_flower":"🥀","drum_with_drumsticks":"🥁","clinking_glasses":"🥂","tumbler_glass":"🥃","spoon":"🥄","goal_net":"🥅","first_place_medal":"🥇","second_place_medal":"🥈","third_place_medal":"🥉","boxing_glove":"🥊","martial_arts_uniform":"🥋","curling_stone":"🥌","croissant":"🥐","avocado":"🥑","cucumber":"🥒","bacon":"🥓","potato":"🥔","carrot":"🥕","baguette_bread":"🥖","green_salad":"🥗","shallow_pan_of_food":"🥘","stuffed_flatbread":"🥙","egg":"🥚","glass_of_milk":"🥛","peanuts":"🥜","kiwifruit":"🥝","pancakes":"🥞","dumpling":"🥟","fortune_cookie":"🥠","takeout_box":"🥡","chopsticks":"🥢","bowl_with_spoon":"🥣","cup_with_straw":"🥤","coconut":"🥥","broccoli":"🥦","pie":"🥧","pretzel":"🥨","cut_of_meat":"🥩","sandwich":"🥪","canned_food":"🥫","crab":"🦀","lion_face":"🦁","scorpion":"🦂","turkey":"🦃","unicorn_face":"🦄","eagle":"🦅","duck":"🦆","bat":"🦇","shark":"🦈","owl":"🦉","fox_face":"🦊","butterfly":"🦋","deer":"🦌","gorilla":"🦍","lizard":"🦎","rhinoceros":"🦏","shrimp":"🦐","squid":"🦑","giraffe_face":"🦒","zebra_face":"🦓","hedgehog":"🦔","sauropod":"🦕","t-rex":"🦖","cricket":"🦗","cheese_wedge":"🧀","face_with_monocle":"🧐","adult":"🧑","child":"🧒","older_adult":"🧓","bearded_person":"🧔","person_with_headscarf":"🧕","woman_in_steamy_room":"🧖‍♀️","man_in_steamy_room":"🧖‍♂️","person_in_steamy_room":"🧖‍♂️","woman_climbing":"🧗‍♀️","person_climbing":"🧗‍♀️","man_climbing":"🧗‍♂️","woman_in_lotus_position":"🧘‍♀️","person_in_lotus_position":"🧘‍♀️","man_in_lotus_position":"🧘‍♂️","female_mage":"🧙‍♀️","mage":"🧙‍♀️","male_mage":"🧙‍♂️","female_fairy":"🧚‍♀️","fairy":"🧚‍♀️","male_fairy":"🧚‍♂️","female_vampire":"🧛‍♀️","vampire":"🧛‍♀️","male_vampire":"🧛‍♂️","mermaid":"🧜‍♀️","merman":"🧜‍♂️","merperson":"🧜‍♂️","female_elf":"🧝‍♀️","male_elf":"🧝‍♂️","elf":"🧝‍♂️","female_genie":"🧞‍♀️","male_genie":"🧞‍♂️","genie":"🧞‍♂️","female_zombie":"🧟‍♀️","male_zombie":"🧟‍♂️","zombie":"🧟‍♂️","brain":"🧠","orange_heart":"🧡","billed_cap":"🧢","scarf":"🧣","gloves":"🧤","coat":"🧥","socks":"🧦","bangbang":"‼️","interrobang":"⁉️","tm":"™️","information_source":"ℹ️","left_right_arrow":"↔️","arrow_up_down":"↕️","arrow_upper_left":"↖️","arrow_upper_right":"↗️","arrow_lower_right":"↘️","arrow_lower_left":"↙️","leftwards_arrow_with_hook":"↩️","arrow_right_hook":"↪️","watch":"⌚","hourglass":"⌛","keyboard":"⌨️","eject":"⏏️","fast_forward":"⏩","rewind":"⏪","arrow_double_up":"⏫","arrow_double_down":"⏬","black_right_pointing_double_triangle_with_vertical_bar":"⏭️","black_left_pointing_double_triangle_with_vertical_bar":"⏮️","black_right_pointing_triangle_with_double_vertical_bar":"⏯️","alarm_clock":"⏰","stopwatch":"⏱️","timer_clock":"⏲️","hourglass_flowing_sand":"⏳","double_vertical_bar":"⏸️","black_square_for_stop":"⏹️","black_circle_for_record":"⏺️","m":"Ⓜ️","black_small_square":"▪️","white_small_square":"▫️","arrow_forward":"▶️","arrow_backward":"◀️","white_medium_square":"◻️","black_medium_square":"◼️","white_medium_small_square":"◽","black_medium_small_square":"◾","sunny":"☀️","cloud":"☁️","umbrella":"☂️","snowman":"☃️","comet":"☄️","phone":"☎️","telephone":"☎️","ballot_box_with_check":"☑️","shamrock":"☘️","point_up":"☝️","skull_and_crossbones":"☠️","radioactive_sign":"☢️","biohazard_sign":"☣️","orthodox_cross":"☦️","star_and_crescent":"☪️","peace_symbol":"☮️","yin_yang":"☯️","wheel_of_dharma":"☸️","white_frowning_face":"☹️","relaxed":"☺️","female_sign":"♀️","male_sign":"♂️","gemini":"♊","cancer":"♋","leo":"♌","virgo":"♍","libra":"♎","scorpius":"♏","spades":"♠️","clubs":"♣️","hearts":"♥️","diamonds":"♦️","hotsprings":"♨️","recycle":"♻️","wheelchair":"♿","hammer_and_pick":"⚒️","crossed_swords":"⚔️","medical_symbol":"⚕️","staff_of_aesculapius":"⚕️","scales":"⚖️","alembic":"⚗️","gear":"⚙️","atom_symbol":"⚛️","fleur_de_lis":"⚜️","warning":"⚠️","zap":"⚡","white_circle":"⚪","black_circle":"⚫","coffin":"⚰️","funeral_urn":"⚱️","soccer":"⚽","baseball":"⚾","snowman_without_snow":"⛄","partly_sunny":"⛅","thunder_cloud_and_rain":"⛈️","ophiuchus":"⛎","pick":"⛏️","helmet_with_white_cross":"⛑️","chains":"⛓️","no_entry":"⛔","shinto_shrine":"⛩️","church":"⛪","mountain":"⛰️","umbrella_on_ground":"⛱️","fountain":"⛲","golf":"⛳","ferry":"⛴️","boat":"⛵","sailboat":"⛵","skier":"⛷️","ice_skate":"⛸️","woman-bouncing-ball":"⛹️‍♀️","man-bouncing-ball":"⛹️‍♂️","person_with_ball":"⛹️‍♂️","tent":"⛺","fuelpump":"⛽","scissors":"✂️","airplane":"✈️","email":"✉️","envelope":"✉️","fist":"✊","hand":"✋","raised_hand":"✋","v":"✌️","writing_hand":"✍️","pencil2":"✏️","black_nib":"✒️","heavy_check_mark":"✔️","heavy_multiplication_x":"✖️","latin_cross":"✝️","star_of_david":"✡️","eight_spoked_asterisk":"✳️","eight_pointed_black_star":"✴️","snowflake":"❄️","sparkle":"❇️","x":"❌","negative_squared_cross_mark":"❎","heavy_heart_exclamation_mark_ornament":"❣️","heart":"❤️","arrow_right":"➡️","curly_loop":"➰","loop":"➿","arrow_heading_up":"⤴️","arrow_heading_down":"⤵️","arrow_left":"⬅️","arrow_up":"⬆️","arrow_down":"⬇️","black_large_square":"⬛","white_large_square":"⬜","star":"⭐","o":"⭕","wavy_dash":"〰️","part_alternation_mark":"〽️","congratulations":"㊗️","secret":"㊙️"}

/***/ }),

/***/ 245:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 246:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(144)
	
	var Component = __webpack_require__(6)(
	  /* script */
	  __webpack_require__(101),
	  /* template */
	  __webpack_require__(255),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 247:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(6)(
	  /* script */
	  __webpack_require__(102),
	  /* template */
	  __webpack_require__(254),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 248:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(6)(
	  /* script */
	  __webpack_require__(103),
	  /* template */
	  __webpack_require__(259),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 249:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(6)(
	  /* script */
	  __webpack_require__(104),
	  /* template */
	  __webpack_require__(258),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 250:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(6)(
	  /* script */
	  __webpack_require__(105),
	  /* template */
	  __webpack_require__(253),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 251:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(6)(
	  /* script */
	  __webpack_require__(106),
	  /* template */
	  __webpack_require__(256),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 252:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(6)(
	  /* script */
	  __webpack_require__(107),
	  /* template */
	  __webpack_require__(257),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 253:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.lastPage) ? _c('ul', {
	    staticClass: "pagination",
	    class: _vm.cssClass
	  }, [(_vm.activePrev) ? _c('li', {
	    staticClass: "page-item"
	  }, [_c('a', {
	    staticClass: "page-link",
	    attrs: {
	      "href": ""
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.prev()
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.prevText))])]) : _c('li', {
	    staticClass: "page-item disabled"
	  }, [_c('span', {
	    staticClass: "page-link"
	  }, [_vm._v(_vm._s(_vm.prevText))])]), _vm._v(" "), _vm._l((_vm.headEnd), function(n) {
	    return _c('li', {
	      staticClass: "page-item",
	      class: {
	        active: _vm.isActive(n)
	      }
	    }, [(_vm.isActive(n)) ? _c('span', {
	      staticClass: "page-link"
	    }, [_vm._v(_vm._s(n))]) : _c('a', {
	      staticClass: "page-link",
	      attrs: {
	        "href": ""
	      },
	      on: {
	        "click": function($event) {
	          $event.preventDefault();
	          return _vm.turn(n)
	        }
	      }
	    }, [_vm._v(_vm._s(n))])])
	  }), _vm._v(" "), (_vm.headEllipsis) ? _c('li', {
	    staticClass: "page-item disabled"
	  }, [_c('span', {
	    staticClass: "page-link"
	  }, [_vm._v("...")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.centerCount), function(n) {
	    return _c('li', {
	      staticClass: "page-item",
	      class: {
	        active: _vm.isActive(n + _vm.centerOffset)
	      }
	    }, [(_vm.isActive(n + _vm.centerOffset)) ? _c('span', {
	      staticClass: "page-link"
	    }, [_vm._v(_vm._s(n + _vm.centerOffset))]) : _c('a', {
	      staticClass: "page-link",
	      attrs: {
	        "href": ""
	      },
	      on: {
	        "click": function($event) {
	          $event.preventDefault();
	          return _vm.turn(n + _vm.centerOffset)
	        }
	      }
	    }, [_vm._v(_vm._s(n + _vm.centerOffset))])])
	  }), _vm._v(" "), (_vm.tailEllipsis) ? _c('li', {
	    staticClass: "page-item disabled"
	  }, [_c('span', {
	    staticClass: "page-link"
	  }, [_vm._v("...")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.tailShowCount), function(n) {
	    return _c('li', {
	      staticClass: "page-item",
	      class: {
	        active: _vm.isActive(n + _vm.tailOffset)
	      }
	    }, [(_vm.isActive(n + _vm.tailOffset)) ? _c('span', {
	      staticClass: "page-link"
	    }, [_vm._v(_vm._s(n + _vm.tailOffset))]) : _c('a', {
	      staticClass: "page-link",
	      attrs: {
	        "href": ""
	      },
	      on: {
	        "click": function($event) {
	          $event.preventDefault();
	          return _vm.turn(n + _vm.tailOffset)
	        }
	      }
	    }, [_vm._v(_vm._s(n + _vm.tailOffset))])])
	  }), _vm._v(" "), (_vm.activeNext) ? _c('li', {
	    staticClass: "page-item"
	  }, [_c('a', {
	    staticClass: "page-link",
	    attrs: {
	      "href": ""
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.next()
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.nextText))])]) : _c('li', {
	    staticClass: "page-item disabled"
	  }, [_c('span', {
	    staticClass: "page-link"
	  }, [_vm._v(_vm._s(_vm.nextText))])])], 2) : _vm._e()
	},staticRenderFns: []}

/***/ }),

/***/ 254:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [(_vm.appIsReady) ? _c('div', [_vm._v("Choose channel")]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),

/***/ 255:
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    class: {
	      'with-menu': _vm.showMenu, 'ready': _vm.appIsReady
	    },
	    attrs: {
	      "id": "app"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.appIsReady),
	      expression: "!appIsReady"
	    }],
	    staticClass: "splash"
	  }, [_c('img', {
	    staticClass: "img-fluid",
	    attrs: {
	      "src": __webpack_require__(82),
	      "alt": "SlackArchives.org"
	    }
	  }), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.error),
	      expression: "!error"
	    }],
	    staticClass: "loader loader-sm"
	  })]), _vm._v(" "), (_vm.error) ? _c('div', {
	    staticClass: "error",
	    class: 'error-' + _vm.errorType
	  }, [_vm._v(_vm._s(_vm.error) + "\n    "), (!_vm.errorType) ? _c('span', [_c('span', {
	    staticClass: "smiley"
	  }, [_vm._v("☹")]), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "http://slack-archives.org/#support",
	      "target": "_blank"
	    }
	  }, [_vm._v("Let us know")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.appIsReady) ? _c('top-bar', {
	    attrs: {
	      "team": _vm.team
	    },
	    on: {
	      "toggleMenu": _vm.onMenuToggle
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.appIsReady) ? _c('side-bar', {
	    attrs: {
	      "team": _vm.team,
	      "channels": _vm.channels
	    }
	  }) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "main-content",
	    attrs: {
	      "id": "main_container"
	    }
	  }, [_c('router-view', {
	    attrs: {
	      "channel": _vm.channel,
	      "team": _vm.team,
	      "channelIDsToName": _vm.channelIDsToName,
	      "appIsReady": _vm.appIsReady
	    },
	    on: {
	      "error": _vm.onError
	    }
	  })], 1)], 1)
	},staticRenderFns: []}

/***/ }),

/***/ 256:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "sidebar",
	    attrs: {
	      "ng-cloak": ""
	    }
	  }, [(_vm.team) ? _c('router-link', {
	    staticClass: "team-name",
	    attrs: {
	      "to": {
	        name: 'home'
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.team.name))]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "content"
	  }, [_c('form', {
	    staticClass: "search-form",
	    attrs: {
	      "id": "searchForm"
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        return _vm.performSearch($event)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.search_query),
	      expression: "search_query"
	    }],
	    staticClass: "search-input",
	    attrs: {
	      "type": "text",
	      "size": "30",
	      "placeholder": "Search..."
	    },
	    domProps: {
	      "value": (_vm.search_query)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.search_query = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.search_query),
	      expression: "!search_query"
	    }],
	    staticClass: "icon icon-search"
	  }), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": ""
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.resetSearch($event)
	      }
	    }
	  }, [_c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.search_query),
	      expression: "search_query"
	    }],
	    staticClass: "icon icon-remove"
	  })])])]), _vm._v(" "), _c('h2', {
	    attrs: {
	      "id": "sepH2"
	    }
	  }, [_c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.search_query),
	      expression: "!search_query"
	    }],
	    staticClass: "filters"
	  }, [_c('a', {
	    class: {
	      active: _vm.activeFilter
	    },
	    attrs: {
	      "href": ""
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.activeFilter = true
	      }
	    }
	  }, [_vm._v("Active")]), _vm._v(" "), _c('a', {
	    class: {
	      active: !_vm.activeFilter
	    },
	    attrs: {
	      "href": ""
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.activeFilter = null
	      }
	    }
	  }, [_vm._v("All")])]), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.areFilteredChannels),
	      expression: "!areFilteredChannels"
	    }]
	  }, [_vm._v("Channels")]), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.areFilteredChannels === true),
	      expression: "areFilteredChannels === true"
	    }]
	  }, [_vm._v("Filter by channel")])]), _vm._v(" "), _c('div', {
	    staticClass: "shadow-container",
	    attrs: {
	      "id": "shadowContainer"
	    }
	  }, [_c('ul', {
	    staticClass: "channels-list",
	    attrs: {
	      "id": "channelsList"
	    }
	  }, _vm._l((_vm.filteredChannels), function(each) {
	    return _c('li', [_c('router-link', {
	      attrs: {
	        "to": {
	          name: (_vm.search_query ? 'channel_search' : 'channel'),
	          params: {
	            channel_name: each.name,
	            search: _vm.search_query
	          }
	        },
	        "id": 'channel-menu-' + each.name
	      }
	    }, [_vm._v("\n            # " + _vm._s(each.name) + "\n            "), (each.results) ? _c('span', {
	      staticClass: "count"
	    }, [_vm._v(_vm._s(each.results))]) : _vm._e()])], 1)
	  }), 0), _vm._v(" "), _c('div', {
	    staticClass: "sofa-scrolling-shadow-top",
	    attrs: {
	      "id": "topShadow"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "sofa-scrolling-shadow-bottom",
	    attrs: {
	      "id": "bottomShadow"
	    }
	  })])])], 1)
	},staticRenderFns: []}

/***/ }),

/***/ 257:
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "header"
	  }, [_c('div', {
	    staticClass: "container-fluid"
	  }, [_c('div', {
	    staticClass: "mobile-header"
	  }, [_c('a', {
	    staticClass: "navbar-toggle",
	    attrs: {
	      "href": ""
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.toggleMenu($event)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "icon-bar"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "icon-bar"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "icon-bar"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "team-name",
	    attrs: {
	      "id": "team"
	    }
	  }, [_vm._v(_vm._s(_vm.team.name))])]), _vm._v(" "), _c('ul', {
	    staticClass: "header-nav"
	  }, [(_vm.team) ? _c('li', [_c('a', {
	    attrs: {
	      "href": 'http://' + _vm.team.domain + '.slack.com/',
	      "target": "_blank"
	    }
	  }, [_vm._v("Open Slack")])]) : _vm._e()]), _vm._v(" "), _vm._m(0)])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "promo"
	  }, [_c('a', {
	    attrs: {
	      "href": "https://slack-archives.org",
	      "target": "_blank"
	    }
	  }, [_c('img', {
	    staticClass: "logo logo-md",
	    attrs: {
	      "src": __webpack_require__(82),
	      "alt": "SlackArchives.org"
	    }
	  }), _vm._v(" "), _c('img', {
	    staticClass: "logo logo-xs",
	    attrs: {
	      "src": __webpack_require__(245),
	      "alt": "SlackArchives.org"
	    }
	  })])])
	}]}

/***/ }),

/***/ 258:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('loader-icon', {
	    staticClass: "messages-loader-top",
	    attrs: {
	      "loading": _vm.isLoading === 'top'
	    }
	  }), _vm._v(" "), _c('ul', {
	    staticClass: "messages",
	    class: {
	      loading: _vm.isLoading === true
	    },
	    attrs: {
	      "id": "messages"
	    }
	  }, [(_vm.realTotalMessages > 10000 && _vm.currentPage === 1) ? _c('li', {
	    staticClass: "msg-danger"
	  }, [_vm._v("\n      Due to performance limitations only 10000 messages can be paginated. "), _c('br', {
	    staticClass: "visible-lg"
	  }), _vm._v("\n      Use search to filter all messages\n      "), (_vm.channel.channel_id) ? _c('span', [_vm._v("in this channel")]) : _vm._e(), _vm._v(" (" + _vm._s(_vm.realTotalMessages) + " messages).\n    ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.messages), function(m) {
	    return _c('li', {
	      class: ['msg-type-' + m.subtype, {
	        'msg-same-user': m.same_user,
	        active: _vm.activeMessageId == m.ts_id
	      }],
	      attrs: {
	        "id": m.ts_id
	      }
	    }, [_c('div', {
	      directives: [{
	        name: "show",
	        rawName: "v-show",
	        value: (m.date_separator),
	        expression: "m.date_separator"
	      }],
	      staticClass: "msg-date-separator"
	    }, [_c('span', [_vm._v(_vm._s(m.date_separator))])]), _vm._v(" "), _c('div', {
	      staticClass: "msg-avatar"
	    }, [(m.user.profile && !m.same_user) ? _c('span', [_c('img', {
	      staticClass: "msg-thumb",
	      attrs: {
	        "src": m.user.profile.image_48
	      }
	    })]) : _vm._e()]), _vm._v(" "), _c('div', {
	      staticClass: "msg-container"
	    }, [_c('div', {
	      directives: [{
	        name: "show",
	        rawName: "v-show",
	        value: (!m.same_user),
	        expression: "!m.same_user"
	      }],
	      staticClass: "msg-header"
	    }, [_c('span', {
	      staticClass: "msg-user"
	    }, [_vm._v(_vm._s(m.user.name))]), _vm._v(" "), _c('span', {
	      staticClass: "msg-time"
	    }, [_c('a', {
	      attrs: {
	        "href": "",
	        "rel": "nofollow"
	      },
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          $event.preventDefault();
	          return _vm.getMessageUrl(m)
	        }
	      }
	    }, [_vm._v(_vm._s(m.date_str))]), _vm._v(" "), (_vm.search && _vm.targetMessageIdLoading == m.ts_id) ? _c('loader-icon', {
	      staticClass: "messages-loader-msg",
	      attrs: {
	        "loading": 1
	      }
	    }) : _vm._e(), _vm._v(" "), (_vm.targetMessageError && _vm.targetMessageId == m.ts_id) ? _c('span', {
	      staticClass: "msg-loading-error"
	    }, [_vm._v(_vm._s(_vm.targetMessageError))]) : _vm._e(), _vm._v(" "), _c('br')], 1)]), _vm._v(" "), _c('div', {
	      staticClass: "msg-body",
	      domProps: {
	        "innerHTML": _vm._s(m.text)
	      }
	    })]), _vm._v(" "), (m.isLast) ? _c('div', {
	      staticClass: "msg-date-separator msg-end-separator"
	    }, [_vm._m(0, true)]) : _vm._e()])
	  }), _vm._v(" "), (_vm.totalMessages === 0 && _vm.channel) ? _c('li', [_c('div', {
	    staticClass: "msg-date-separator msg-end-separator"
	  }, [_c('span', [_c('em', [_vm._v("༄")]), _vm._v(" No messages in channel #" + _vm._s(_vm.channel.name) + " "), _c('em', {
	    staticClass: "end-mark",
	    attrs: {
	      "dir": "rtl"
	    }
	  }, [_vm._v("༄")])])])]) : _vm._e()], 2), _vm._v(" "), _c('loader-icon', {
	    staticClass: "messages-loader-center",
	    attrs: {
	      "loading": _vm.isLoading === true,
	      "size": 'sm'
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "messages-loader-bottom"
	  }, [_c('loader-icon', {
	    attrs: {
	      "loading": _vm.isLoading === 'bottom'
	    }
	  })], 1), _vm._v(" "), (_vm.appIsReady) ? _c('div', {
	    staticClass: "pagination-container",
	    attrs: {
	      "id": "pagination"
	    }
	  }, [_c('paginate', {
	    attrs: {
	      "center-side": 2,
	      "side": 1,
	      "last-page": _vm.lastPage,
	      "current-page": _vm.currentPage,
	      "css-class": 'pagination-vertical',
	      "next-text": '▼',
	      "prev-text": '▲',
	      "url-sync": false
	    },
	    on: {
	      "turn": _vm.changePage
	    }
	  })], 1) : _vm._e()], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [_vm._v("༄ No more new messages  "), _c('em', {
	    staticClass: "end-mark",
	    attrs: {
	      "dir": "rtl"
	    }
	  }, [_vm._v("༄")])])
	}]}

/***/ }),

/***/ 259:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticClass: "loader",
	    class: 'loader-' + (_vm.size ? _vm.size : 'xs')
	  }, [_vm._v(_vm._s(_vm.size))])
	},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/app.8bb29d210701c8f7f520.js